<template>
    <div class="LeadApplyDetailsWarp">
        <div class="titleBox">头雁人才报名详情</div>
        <div class="singupdialogcenter">
            <div class="courseBox1">
                <div class="courseinfo">
                    <span class="text">课程编码</span>
                    <span>{{trainCode}}</span>
                </div>
                <div class="courseinfo">
                    <span class="text">课程名称</span>
                    <span>{{trainCourse}}</span>
                </div>
            </div>
            <div class="singupForm">
                <el-form :model="formData" ref="formData" :rules='formRules' label-width="125px" class="demo-dynamic">
                    <!-- 预审核 -->
                    <div v-if="auditResult==1">
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item label="姓名" prop="userName">
                                    <el-input placeholder="请输入姓名" v-model="formData.userName"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="身份证号码" prop="cardId">
                                    <el-input placeholder="请输入身份证号码" v-model="formData.cardId"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item label="手机号" prop="phone">
                                    <el-input placeholder="请输入手机号" v-model="formData.phone"></el-input>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="企业名称" prop="leaderPersionGropBo.name">
                                    <el-input placeholder="请输入企业名称" v-model="formData.leaderPersionGropBo.name" :disabled="true"></el-input>
                                </el-form-item>
                            </el-col>
                        </el-row>
                    </div>
                    <!-- 詳細信息 -->
                    <div v-else-if="auditResult==98||auditResult==99||auditResult==199">
                        <div class="singupInfowarp">
                            <div class="singupInfobox">
                                <el-row :gutter="20">
                                    <el-col :span="12">
                                        <el-form-item label="姓名" prop="userName">
                                            <el-input placeholder="请输入姓名" v-model="formData.userName" :disabled="true"></el-input>
                                        </el-form-item>
                                    </el-col>

                                    <el-col :span="12">
                                        <el-form-item label="民族" prop="ethnic">
                                            <el-select v-model="formData.ethnic" placeholder="请选择民族" style="width:100%">
                                                <el-option v-for="ele in nationArr" :key="ele.dictionariesId" :label="ele.dictMsg" :value="ele.dictionariesId">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row :gutter="20">
                                    <el-col :span="12">
                                        <el-form-item label="性别" prop="sex">
                                            <el-select v-model="formData.sex" placeholder="请选择性别" style="width:100%" :disabled="true">
                                                <el-option v-for="ele in sexArr" :key="ele.dictionariesId" :label="ele.dictMsg" :value="ele.dictionariesId">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="政治面貌" prop="politics">
                                            <el-select v-model="formData.politics" placeholder="请选择政治面貌" style="width:100%">
                                                <el-option v-for="ele in politicsArr" :key="ele.dictionariesId" :label="ele.dictMsg" :value="ele.dictionariesId">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row :gutter="20">
                                    <el-col :span="12">
                                        <el-form-item label="出生日期" prop="birthDay">
                                            <el-date-picker type="date" placeholder="请选择出生日期" v-model="formData.birthDay" style="width: 100%;" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                                                :disabled="true"></el-date-picker>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="现任职务" prop="post">
                                            <el-input placeholder="请输入现任职务" v-model="formData.post"></el-input>
                                        </el-form-item>
                                    </el-col>

                                </el-row>
                                <el-row :gutter="20">
                                    <el-col :span="12">
                                        <el-form-item label="身份证号码" prop="cardId">
                                            <el-input placeholder="请输入身份证号码" v-model="formData.cardId" :disabled="true"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="管理经验年限" prop="manageList">
                                            <el-input placeholder="请输入管理经验年限" v-model="formData.manageList"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row :gutter="20">
                                    <el-col :span="12">
                                        <el-form-item label="电子邮箱" prop="email">
                                            <el-input placeholder="请输入电子邮箱" v-model="formData.email"></el-input>
                                        </el-form-item>
                                    </el-col>

                                    <el-col :span="12">
                                        <el-form-item label="通讯地址 " prop="address">
                                            <el-input placeholder="请输入通讯地址 " v-model="formData.address"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <div class="header honor">个人荣誉和奖励
                                </div>
                                <el-row :gutter="20">
                                    <el-col :span="24">
                                        <el-form-item label="" prop="honor">
                                            <el-input placeholder="请输入" type="textarea" :rows="6" v-model="formData.honor"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </div>
                            <div class="singupInfobox">
                                <div class="header">教育背景
                                    <span class="education">(最高学历)</span>
                                </div>
                                <el-row :gutter="10">
                                    <el-col :span="12">
                                        <el-form-item label="毕业院校" prop="school">
                                            <el-input placeholder="请输入毕业院校" v-model="formData.school"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="起止时间" prop="times">
                                            <el-date-picker v-model="formData.times" format="yyyy-MM" value-format="yyyy-MM" unlink-panels type="monthrange" range-separator="至"
                                                start-placeholder="开始日期" end-placeholder="结束日期" style="width:100%" placeholder="请选择起止时间">
                                            </el-date-picker>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row :gutter="10">

                                    <el-col :span="12">
                                        <el-form-item label="专业" prop="major">
                                            <el-input placeholder="请输入专业" v-model="formData.major"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="学历/学位" prop="education">
                                            <el-select v-model="formData.education" placeholder="请选择学历/学位" style="width:100%">
                                                <el-option v-for="ele in educationArr" :key="ele.dictionariesId" :label="ele.dictMsg" :value="ele.dictionariesId">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </div>
                            <div class="singupInfobox">
                                <div class="header">企业情况</div>
                                <el-row :gutter="20">
                                    <el-col :span="12">
                                        <el-form-item label="企业名称" prop="leaderPersionGropBo.name">
                                            <el-input placeholder="请输入企业名称" v-model="formData.leaderPersionGropBo.name" :disabled="true"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="企业类型 " prop="leaderPersionGropBo.corpType">
                                            <el-select v-model="formData.leaderPersionGropBo.corpType" placeholder="请选择" style="width:100%">
                                                <el-option v-for="ele in corpTypeArr" :key="ele.dictionariesId" :label="ele.dictMsg" :value="ele.dictionariesId"></el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>

                                </el-row>
                                <el-row :gutter="20">
                                    <el-col :span="12">
                                        <el-form-item label="组织机构代码 " prop="leaderPersionGropBo.organizingCord">
                                            <el-input placeholder="请输入 " v-model="formData.leaderPersionGropBo.organizingCord"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="公司网址 " prop="leaderPersionGropBo.website">
                                            <el-input placeholder="请输入公司网址 " v-model="formData.leaderPersionGropBo.website"></el-input>
                                        </el-form-item>
                                    </el-col>

                                </el-row>
                                <el-row :gutter="20">

                                    <el-col :span="12">
                                        <el-form-item label="所属行业" prop="leaderPersionGropBo.industry">
                                            <el-input placeholder="请输入所属行业" v-model="formData.leaderPersionGropBo.industry"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="行业细分领域" prop="leaderPersionGropBo.industryDetails">
                                            <el-input placeholder="请输入所属行业" v-model="formData.leaderPersionGropBo.industryDetails"></el-input>
                                        </el-form-item>
                                    </el-col>

                                </el-row>

                                <el-row :gutter="20">
                                    <el-col :span="12">
                                        <el-form-item label="是否上市" prop="leaderPersionGropBo.listed">
                                            <el-radio-group v-model="formData.leaderPersionGropBo.listed" @change='changeSsFn'>
                                                <el-radio label="是"></el-radio>
                                                <el-radio label="否"></el-radio>
                                            </el-radio-group>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12" v-if="isListed">
                                        <el-form-item label="三年内有无上市计划 " prop="leaderPersionGropBo.beforeList" label-width="150px">
                                            <el-radio-group v-model="formData.leaderPersionGropBo.beforeList" @change='changeSsjhFn'>
                                                <el-radio label="有"></el-radio>
                                                <el-radio label="无"></el-radio>
                                            </el-radio-group>
                                        </el-form-item>
                                    </el-col>

                                </el-row>
                                <el-row :gutter="20" v-if="isListingPlan">
                                    <el-col :span="12">
                                        <el-form-item label="上市进程" prop="leaderPersionGropBo.listProcess">
                                            <el-select v-model="formData.leaderPersionGropBo.listProcess" placeholder="请选择" style="width:100%">
                                                <el-option v-for="ele in listProcessArr" :key="ele.dictionariesId" :label="ele.dictMsg" :value="ele.dictionariesId"></el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>

                                    <el-col :span="12">
                                        <el-form-item label="拟上市板块 " prop="leaderPersionGropBo.listPlate">
                                            <el-select v-model="formData.leaderPersionGropBo.listPlate" placeholder="请选择" style="width:100%">
                                                <el-option v-for="ele in listPlateArr" :key="ele.dictionariesId" :label="ele.dictMsg" :value="ele.dictionariesId">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                </el-row>

                                <el-row :gutter="20">
                                    <el-col :span="2">
                                        <div class="yearbox">{{newyear}}年</div>
                                    </el-col>
                                    <el-col :span="5">
                                        <el-form-item label="" prop="leaderPersionGropBo.propertyBo.yesterassets" label-width="0px">
                                            <el-input placeholder="请输入资产总额（万元）" v-model="formData.leaderPersionGropBo.propertyBo.yesterassets"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="5">
                                        <el-form-item label="" prop="leaderPersionGropBo.propertyBo.yetersale" label-width="0px">
                                            <el-input placeholder=" 年销售额（万元） " v-model="formData.leaderPersionGropBo.propertyBo.yetersale"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="5">
                                        <el-form-item label="" prop="leaderPersionGropBo.propertyBo.yesterstaffNum" label-width="0px">
                                            <el-input placeholder="员工人数（人）" v-model="formData.leaderPersionGropBo.propertyBo.yesterstaffNum"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="7">
                                        <el-form-item label="" prop="leaderPersionGropBo.propertyBo.yestergrowth" label-width="0px">
                                            <el-input placeholder="年利润增长率（与上一年比较）" v-model="formData.leaderPersionGropBo.propertyBo.yestergrowth"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row :gutter="20">
                                    <el-col :span="2">
                                        <div class="yearbox">{{nextyear}}年</div>
                                    </el-col>
                                    <el-col :span="5">
                                        <el-form-item label="" prop="leaderPersionGropBo.propertyBo.beforeassets" label-width="0px">
                                            <el-input placeholder="请输入资产总额（万元）" v-model="formData.leaderPersionGropBo.propertyBo.beforeassets"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="5">
                                        <el-form-item label="" prop="leaderPersionGropBo.propertyBo.beforesale" label-width="0px">
                                            <el-input placeholder=" 年销售额（万元） " v-model="formData.leaderPersionGropBo.propertyBo.beforesale"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="5">
                                        <el-form-item label="" prop="leaderPersionGropBo.propertyBo.beforestaffNum" label-width="0px">
                                            <el-input placeholder="员工人数（人）" v-model="formData.leaderPersionGropBo.propertyBo.beforestaffNum"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="7">
                                        <el-form-item label="" prop="leaderPersionGropBo.propertyBo.beforegrowth" label-width="0px">
                                            <el-input placeholder="年利润增长率（与上一年比较）" v-model="formData.leaderPersionGropBo.propertyBo.beforegrowth"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <div class="header">
                                    企业主导产品情况
                                </div>
                                <el-row :gutter="20">
                                    <el-col :span="12">
                                        <el-form-item label="主导产品名称" prop="leaderPersionGropBo.leadingProduct">
                                            <el-input placeholder="请输入" v-model="formData.leaderPersionGropBo.leadingProduct"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="主导产品类别" prop="leaderPersionGropBo.leadingProductType">
                                            <el-input placeholder="请输入" v-model="formData.leaderPersionGropBo.leadingProductType"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row :gutter="20">
                                    <el-col :span="12">
                                        <el-form-item label="主导产品时间" prop="leaderPersionGropBo.leadingProductYear">
                                            <el-input placeholder="请输入" v-model="formData.leaderPersionGropBo.leadingProductYear"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">

                                        <el-form-item label="主营业务收入占比" prop="leaderPersionGropBo.leadingProductProportion" label-width="140px">
                                            <el-input placeholder="请输入" v-model="formData.leaderPersionGropBo.leadingProductProportion"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <div style="fontSize:18px;margin:16px 0px 30px 0">拥有与主导产品有关的I类知识产权情况</div>
                                <el-row :gutter="20">
                                    <el-col :span="8">
                                        <el-form-item label="知识产权总数" prop="leaderPersionGropBo.patentNum">
                                            <el-input placeholder="请输入" v-model="formData.leaderPersionGropBo.patentNum"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">

                                        <el-form-item label="发明专利数量" prop="leaderPersionGropBo.patent1" label-width="140px">
                                            <el-input placeholder="请输入" v-model="formData.leaderPersionGropBo.patent1"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">

                                        <el-form-item label="植物新品种数" prop="leaderPersionGropBo.patent2" label-width="140px">
                                            <el-input placeholder="请输入" v-model="formData.leaderPersionGropBo.patent2"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row :gutter="20">
                                    <el-col :span="8">
                                        <el-form-item label="国家级农作物品种数" prop="leaderPersionGropBo.patent3" label-width="160px">
                                            <el-input placeholder="请输入" v-model="formData.leaderPersionGropBo.patent3"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">

                                        <el-form-item label="国家新药数量" prop="leaderPersionGropBo.patent4" label-width="160px">
                                            <el-input placeholder="请输入" v-model="formData.leaderPersionGropBo.patent4"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">

                                        <el-form-item label="集成电路布图设计专有权数" prop="leaderPersionGropBo.patent5" label-width="200px">
                                            <el-input placeholder="请输入" v-model="formData.leaderPersionGropBo.patent5"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row :gutter="20">
                                    <el-col :span="9">
                                        <el-form-item label="是否为国内外知名大企业直接配套" prop="leaderPersionGropBo.isDirectMating" label-width="240px">
                                            <el-radio-group v-model="formData.leaderPersionGropBo.isDirectMating" @change='changeMating'>
                                                <el-radio label="是"></el-radio>
                                                <el-radio label="否"></el-radio>
                                            </el-radio-group>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8" v-if="isMating">
                                        <el-form-item label="相关产品 " prop="leaderPersionGropBo.directMatingNames" label-width="150px">
                                            <el-input placeholder="请输入" v-model="formData.leaderPersionGropBo.directMatingNames"></el-input>
                                        </el-form-item>
                                    </el-col>

                                </el-row>

                                <div class="header">企业数字化赋能情况</div>
                                <el-row :gutter="20">
                                    <el-col :span="12">
                                        <el-form-item label="业务系统是否向云端迁" prop="leaderPersionGropBo.isCloudCorner" label-width="170px">
                                            <el-radio-group v-model="formData.leaderPersionGropBo.isCloudCorner">
                                                <el-radio label="有"></el-radio>
                                                <el-radio label="无"></el-radio>
                                            </el-radio-group>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="有无制造业和工业互联网融合示范项目" prop="leaderPersionGropBo.havCoalesceProject" label-width="270px">
                                            <el-radio-group v-model="formData.leaderPersionGropBo.havCoalesceProject	">
                                                <el-radio label="有"></el-radio>
                                                <el-radio label="无"></el-radio>
                                            </el-radio-group>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row :gutter="20">
                                    <el-col :span="24">
                                        <el-form-item label="核心业务采用信息系统支撑情况(可多选)  " prop="leaderPersionGropBo.coreBusinessSystem" label-width="280px">
                                            <el-checkbox-group v-model="formData.leaderPersionGropBo.coreBusinessSystem" style="width:100%" @change="handleCheckedCitiesChange">
                                                <el-checkbox v-for="ele in coreBusinessSystemArr" :label="ele.dictionariesId" :key="ele.dictionariesId">{{ele.dictMsg}}</el-checkbox>
                                            </el-checkbox-group>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row :gutter="20" v-if="isInput">
                                    <el-col :span="24">
                                        <el-form-item label="核心业务采用信息系统支撑情况其他情况说明  " prop="leaderPersionGropBo.coreBusinessSystemExplain" label-width="300px">
                                            <el-input placeholder="限150字" type="textarea" maxlength="150" show-word-limit :rows="3" v-model="formData.leaderPersionGropBo.coreBusinessSystemExplain"></el-input>
                                        </el-form-item>
                                    </el-col>

                                </el-row>
                                <div class="header">
                                    企业认证情况
                                </div>
                                <el-row :gutter="20">
                                    <el-col :span="12">
                                        <el-form-item label="产品生产执行标准" prop="leaderPersionGropBo.productStandard" label-width="150px">
                                            <el-select v-model="formData.leaderPersionGropBo.productStandard" placeholder="请选择" style="width:100%">
                                                <el-option v-for="ele in productStandardArr" :key="ele.dictionariesId" :label="ele.dictMsg" :value="ele.dictionariesId"></el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="产品获得发达国家或地区权威认证 " prop="leaderPersionGropBo.regionalCertification" label-width="240px">
                                            <el-select v-model="formData.leaderPersionGropBo.regionalCertification" placeholder="请选择" style="width:100%">
                                                <el-option v-for="ele in regionalCertificationArr" :key="ele.dictionariesId" :label="ele.dictMsg" :value="ele.dictionariesId"></el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row :gutter="20">
                                    <el-col :span="12">
                                        <el-form-item label="企业获得的管理体系认证" prop="leaderPersionGropBo.managerCertification" label-width="180px">
                                            <el-select v-model="formData.leaderPersionGropBo.managerCertification" placeholder="请选择" style="width:100%">
                                                <el-option v-for="ele in managerCertificationArr" :key="ele.dictionariesId" :label="ele.dictMsg" :value="ele.dictionariesId"></el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="获得相关部门认定的称号 " prop="leaderPersionGropBo.governmentCertification" label-width="180px">
                                            <el-select v-model="formData.leaderPersionGropBo.governmentCertification" placeholder="请选择" style="width:100%">
                                                <el-option v-for="ele in governmentCertificationArr" :key="ele.dictionariesId" :label="ele.dictMsg" :value="ele.dictionariesId"></el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row :gutter="20" v-if="isGovernment">
                                    <el-col :span="12">
                                        <el-form-item label="其他称号说明" prop="leaderPersionGropBo.governmentCertificationExplain" label-width="180px">
                                            <el-input placeholder="请输入" v-model="formData.leaderPersionGropBo.governmentCertificationExplain"></el-input>
                                        </el-form-item>
                                    </el-col>

                                </el-row>
                                <div class="header honor">企业荣誉和奖励
                                </div>
                                <el-row :gutter="20">
                                    <el-col :span="24">
                                        <el-form-item label="" prop="leaderPersionGropBo.honor">
                                            <el-input placeholder="请输入" type="textarea" :rows="6" v-model="formData.leaderPersionGropBo.honor"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <div class="header">
                                    企业简介
                                    <span class="education">(企业总体情况简要介绍，主要说明主导产品的技术先进性、市场占有份额、发展前景等，800字以内)</span>
                                </div>
                                <el-row :gutter="20">
                                    <el-col :span="24">
                                        <el-form-item label="" prop="leaderPersionGropBo.companyIntro">
                                            <el-input placeholder="（请说明）" type="textarea" maxlength="800" :rows="4" v-model="formData.leaderPersionGropBo.companyIntro"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </div>
                        </div>

                    </div>
                    <div v-else-if="auditResult==3||auditResult==101||auditResult==100">
                        <div class="fileBox">
                            <div class="header">报名表信息</div>
                        </div>
                        <div class="makeoutInfoBox">

                            <el-row :gutter="20">
                                <el-col :span="12">
                                    <!-- <div class="textbox" @click="downloadRecommendFn">
                                        <span>查看</span>下载领军人才学员选拔表
                                        <i class="el-icon-download iconbox" />
                                    </div> -->
                                    <div class="textbox">
                                        <div class="leftbox"><img class="imgbox" src="@/assets/imgs/lead/file.png">
                                            <span>《选拔表》</span>
                                        </div>
                                        <div class="downBox" @click="downloadRecommendFn">下载</div>
                                    </div>
                                </el-col>
                                <el-col :span="12">
                                    <!-- <div class="textbox" @click="downloadFileFn">
                                        <span>查看</span>下载领军人才推荐信
                                        <i class="el-icon-download iconbox" />
                                    </div> -->
                                    <div class="textbox">
                                        <div class="leftbox"><img class="imgbox" src="@/assets/imgs/lead/file.png">
                                            <span>《推荐信》</span>
                                        </div>
                                        <div class="downBox" @click="downloadFileFn">下载</div>
                                    </div>
                                </el-col>
                            </el-row>
                            <el-row :gutter="20">
                                <el-col :span="12">
                                    <el-form-item label="1.学员选拔表" prop="selectinfo">
                                        <el-upload id="imgupload" ref="imgupload" accept=".jpg,.png,.jpeg" list-type="picture-card" :on-success="handleAvatarSuccess"
                                            :on-remove="handleRemove" :action="actionUrl" :headers="header" :limit="1" :file-list="imgfileList">
                                            <i class="el-icon-plus"></i>
                                        </el-upload>
                                    </el-form-item>

                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="2.推荐信扫描件" prop="nominate">
                                        <el-upload id="letterupload" accept=".jpg,.png,.jpeg" list-type="picture-card" :on-success="letterSuccess" :on-remove="letterRemove"
                                            :action="actionUrl" :headers="header" :limit="1" :file-list="letterfileList">
                                            <i class="el-icon-plus"></i>
                                        </el-upload>

                                    </el-form-item>

                                </el-col>
                            </el-row>

                        </div>
                    </div>

                    <div v-else-if="auditResult==2||auditResult==4||auditResult==5">
                        <div class="singupInfowarp">
                            <div class="singupInfobox">
                                <el-row :gutter="20">
                                    <el-col :span="12">
                                        <el-form-item label="姓名" prop="userName">
                                            <el-input placeholder="请输入姓名" v-model="formData.userName" :disabled="true"></el-input>
                                        </el-form-item>
                                    </el-col>

                                    <el-col :span="12">
                                        <el-form-item label="民族" prop="ethnic">
                                            <el-select v-model="formData.ethnic" placeholder="请选择民族" style="width:100%">
                                                <el-option v-for="ele in nationArr" :key="ele.dictionariesId" :label="ele.dictMsg" :value="ele.dictionariesId">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row :gutter="20">
                                    <el-col :span="12">
                                        <el-form-item label="性别" prop="sex">
                                            <el-select v-model="formData.sex" placeholder="请选择性别" style="width:100%" :disabled="true">
                                                <el-option v-for="ele in sexArr" :key="ele.dictionariesId" :label="ele.dictMsg" :value="ele.dictionariesId">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="政治面貌" prop="politics">
                                            <el-select v-model="formData.politics" placeholder="请选择政治面貌" style="width:100%">
                                                <el-option v-for="ele in politicsArr" :key="ele.dictionariesId" :label="ele.dictMsg" :value="ele.dictionariesId">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row :gutter="20">
                                    <el-col :span="12">
                                        <el-form-item label="出生日期" prop="birthDay">
                                            <el-date-picker type="date" placeholder="请选择出生日期" v-model="formData.birthDay" style="width: 100%;" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                                                :disabled="true"></el-date-picker>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="现任职务" prop="post">
                                            <el-input placeholder="请输入现任职务" v-model="formData.post"></el-input>
                                        </el-form-item>
                                    </el-col>

                                </el-row>
                                <el-row :gutter="20">
                                    <el-col :span="12">
                                        <el-form-item label="身份证号码" prop="cardId">
                                            <el-input placeholder="请输入身份证号码" v-model="formData.cardId" :disabled="true"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="管理经验年限" prop="manageList">
                                            <el-input placeholder="请输入管理经验年限" v-model="formData.manageList"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row :gutter="20">
                                    <el-col :span="12">
                                        <el-form-item label="电子邮箱" prop="email">
                                            <el-input placeholder="请输入电子邮箱" v-model="formData.email"></el-input>
                                        </el-form-item>
                                    </el-col>

                                    <el-col :span="12">
                                        <el-form-item label="通讯地址 " prop="address">
                                            <el-input placeholder="请输入通讯地址 " v-model="formData.address"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <div class="header honor">个人荣誉和奖励
                                </div>
                                <el-row :gutter="20">
                                    <el-col :span="24">
                                        <el-form-item label="" prop="honor">
                                            <el-input placeholder="请输入" type="textarea" :rows="6" v-model="formData.honor"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </div>
                            <div class="singupInfobox">
                                <div class="header">教育背景
                                    <span class="education">(最高学历)</span>
                                </div>
                                <el-row :gutter="10">
                                    <el-col :span="12">
                                        <el-form-item label="毕业院校" prop="school">
                                            <el-input placeholder="请输入毕业院校" v-model="formData.school"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="起止时间" prop="times">
                                            <el-date-picker v-model="formData.times" format="yyyy-MM" value-format="yyyy-MM" unlink-panels type="monthrange" range-separator="至"
                                                start-placeholder="开始日期" end-placeholder="结束日期" style="width:100%" placeholder="请选择起止时间">
                                            </el-date-picker>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row :gutter="10">

                                    <el-col :span="12">
                                        <el-form-item label="专业" prop="major">
                                            <el-input placeholder="请输入专业" v-model="formData.major"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="学历/学位" prop="education">
                                            <el-select v-model="formData.education" placeholder="请选择学历/学位" style="width:100%">
                                                <el-option v-for="ele in educationArr" :key="ele.dictionariesId" :label="ele.dictMsg" :value="ele.dictionariesId">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </div>
                            <div class="singupInfobox">
                                <div class="header">企业情况</div>
                                <el-row :gutter="20">
                                    <el-col :span="12">
                                        <el-form-item label="企业名称" prop="leaderPersionGropBo.name">
                                            <el-input placeholder="请输入企业名称" v-model="formData.leaderPersionGropBo.name" :disabled="true"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="企业类型 " prop="leaderPersionGropBo.corpType">
                                            <el-select v-model="formData.leaderPersionGropBo.corpType" placeholder="请选择" style="width:100%">
                                                <el-option v-for="ele in corpTypeArr" :key="ele.dictionariesId" :label="ele.dictMsg" :value="ele.dictionariesId"></el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>

                                </el-row>
                                <el-row :gutter="20">
                                    <el-col :span="12">
                                        <el-form-item label="组织机构代码 " prop="leaderPersionGropBo.organizingCord">
                                            <el-input placeholder="请输入 " v-model="formData.leaderPersionGropBo.organizingCord"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="公司网址 " prop="leaderPersionGropBo.website">
                                            <el-input placeholder="请输入公司网址 " v-model="formData.leaderPersionGropBo.website"></el-input>
                                        </el-form-item>
                                    </el-col>

                                </el-row>
                                <el-row :gutter="20">

                                    <el-col :span="12">
                                        <el-form-item label="所属行业" prop="leaderPersionGropBo.industry">
                                            <el-input placeholder="请输入所属行业" v-model="formData.leaderPersionGropBo.industry"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="行业细分领域" prop="leaderPersionGropBo.industryDetails">
                                            <el-input placeholder="请输入所属行业" v-model="formData.leaderPersionGropBo.industryDetails"></el-input>
                                        </el-form-item>
                                    </el-col>

                                </el-row>

                                <el-row :gutter="20">
                                    <el-col :span="12">
                                        <el-form-item label="是否上市" prop="leaderPersionGropBo.listed">
                                            <el-radio-group v-model="formData.leaderPersionGropBo.listed" @change='changeSsFn'>
                                                <el-radio label="是"></el-radio>
                                                <el-radio label="否"></el-radio>
                                            </el-radio-group>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12" v-if="isListed">
                                        <el-form-item label="三年内有无上市计划 " prop="leaderPersionGropBo.beforeList" label-width="150px">
                                            <el-radio-group v-model="formData.leaderPersionGropBo.beforeList" @change='changeSsjhFn'>
                                                <el-radio label="有"></el-radio>
                                                <el-radio label="无"></el-radio>
                                            </el-radio-group>
                                        </el-form-item>
                                    </el-col>

                                </el-row>
                                <el-row :gutter="20" v-if="isListingPlan">
                                    <el-col :span="12">
                                        <el-form-item label="上市进程" prop="leaderPersionGropBo.listProcess">
                                            <el-select v-model="formData.leaderPersionGropBo.listProcess" placeholder="请选择" style="width:100%">
                                                <el-option v-for="ele in listProcessArr" :key="ele.dictionariesId" :label="ele.dictMsg" :value="ele.dictionariesId"></el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>

                                    <el-col :span="12">
                                        <el-form-item label="拟上市板块 " prop="leaderPersionGropBo.listPlate">
                                            <el-select v-model="formData.leaderPersionGropBo.listPlate" placeholder="请选择" style="width:100%">
                                                <el-option v-for="ele in listPlateArr" :key="ele.dictionariesId" :label="ele.dictMsg" :value="ele.dictionariesId">
                                                </el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                </el-row>

                                <el-row :gutter="20">
                                    <el-col :span="2">
                                        <div class="yearbox">{{newyear}}年</div>
                                    </el-col>
                                    <el-col :span="5">
                                        <el-form-item label="" prop="leaderPersionGropBo.propertyBo.yesterassets" label-width="0px">
                                            <el-input placeholder="请输入资产总额（万元）" v-model="formData.leaderPersionGropBo.propertyBo.yesterassets"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="5">
                                        <el-form-item label="" prop="leaderPersionGropBo.propertyBo.yetersale" label-width="0px">
                                            <el-input placeholder=" 年销售额（万元） " v-model="formData.leaderPersionGropBo.propertyBo.yetersale"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="5">
                                        <el-form-item label="" prop="leaderPersionGropBo.propertyBo.yesterstaffNum" label-width="0px">
                                            <el-input placeholder="员工人数（人）" v-model="formData.leaderPersionGropBo.propertyBo.yesterstaffNum"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="7">
                                        <el-form-item label="" prop="leaderPersionGropBo.propertyBo.yestergrowth" label-width="0px">
                                            <el-input placeholder="年利润增长率（与上一年比较）" v-model="formData.leaderPersionGropBo.propertyBo.yestergrowth"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row :gutter="20">
                                    <el-col :span="2">
                                        <div class="yearbox">{{nextyear}}年</div>
                                    </el-col>
                                    <el-col :span="5">
                                        <el-form-item label="" prop="leaderPersionGropBo.propertyBo.beforeassets" label-width="0px">
                                            <el-input placeholder="请输入资产总额（万元）" v-model="formData.leaderPersionGropBo.propertyBo.beforeassets"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="5">
                                        <el-form-item label="" prop="leaderPersionGropBo.propertyBo.beforesale" label-width="0px">
                                            <el-input placeholder=" 年销售额（万元） " v-model="formData.leaderPersionGropBo.propertyBo.beforesale"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="5">
                                        <el-form-item label="" prop="leaderPersionGropBo.propertyBo.beforestaffNum" label-width="0px">
                                            <el-input placeholder="员工人数（人）" v-model="formData.leaderPersionGropBo.propertyBo.beforestaffNum"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="7">
                                        <el-form-item label="" prop="leaderPersionGropBo.propertyBo.beforegrowth" label-width="0px">
                                            <el-input placeholder="年利润增长率（与上一年比较）" v-model="formData.leaderPersionGropBo.propertyBo.beforegrowth"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <div class="header">
                                    企业主导产品情况
                                </div>
                                <el-row :gutter="20">
                                    <el-col :span="12">
                                        <el-form-item label="主导产品名称" prop="leaderPersionGropBo.leadingProduct">
                                            <el-input placeholder="请输入" v-model="formData.leaderPersionGropBo.leadingProduct"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="主导产品类别" prop="leaderPersionGropBo.leadingProductType">
                                            <el-input placeholder="请输入" v-model="formData.leaderPersionGropBo.leadingProductType"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row :gutter="20">
                                    <el-col :span="12">
                                        <el-form-item label="主导产品时间" prop="leaderPersionGropBo.leadingProductYear">
                                            <el-input placeholder="请输入" v-model="formData.leaderPersionGropBo.leadingProductYear"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">

                                        <el-form-item label="主营业务收入占比" prop="leaderPersionGropBo.leadingProductProportion" label-width="140px">
                                            <el-input placeholder="请输入" v-model="formData.leaderPersionGropBo.leadingProductProportion"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <div style="fontSize:18px;margin:16px 0px 30px 0">拥有与主导产品有关的I类知识产权情况</div>
                                <el-row :gutter="20">
                                    <el-col :span="8">
                                        <el-form-item label="知识产权总数" prop="leaderPersionGropBo.patentNum">
                                            <el-input placeholder="请输入" v-model="formData.leaderPersionGropBo.patentNum"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">

                                        <el-form-item label="发明专利数量" prop="leaderPersionGropBo.patent1" label-width="140px">
                                            <el-input placeholder="请输入" v-model="formData.leaderPersionGropBo.patent1"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">

                                        <el-form-item label="植物新品种数" prop="leaderPersionGropBo.patent2" label-width="140px">
                                            <el-input placeholder="请输入" v-model="formData.leaderPersionGropBo.patent2"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row :gutter="20">
                                    <el-col :span="8">
                                        <el-form-item label="国家级农作物品种数" prop="leaderPersionGropBo.patent3" label-width="160px">
                                            <el-input placeholder="请输入" v-model="formData.leaderPersionGropBo.patent3"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">

                                        <el-form-item label="国家新药数量" prop="leaderPersionGropBo.patent4" label-width="160px">
                                            <el-input placeholder="请输入" v-model="formData.leaderPersionGropBo.patent4"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8">

                                        <el-form-item label="集成电路布图设计专有权数" prop="leaderPersionGropBo.patent5" label-width="200px">
                                            <el-input placeholder="请输入" v-model="formData.leaderPersionGropBo.patent5"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row :gutter="20">
                                    <el-col :span="9">
                                        <el-form-item label="是否为国内外知名大企业直接配套" prop="leaderPersionGropBo.isDirectMating" label-width="240px">
                                            <el-radio-group v-model="formData.leaderPersionGropBo.isDirectMating" @change='changeMating'>
                                                <el-radio label="是"></el-radio>
                                                <el-radio label="否"></el-radio>
                                            </el-radio-group>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="8" v-if="isMating">
                                        <el-form-item label="相关产品 " prop="leaderPersionGropBo.directMatingNames" label-width="150px">
                                            <el-input placeholder="请输入" v-model="formData.leaderPersionGropBo.directMatingNames"></el-input>
                                        </el-form-item>
                                    </el-col>

                                </el-row>

                                <div class="header">企业数字化赋能情况</div>
                                <el-row :gutter="20">
                                    <el-col :span="12">
                                        <el-form-item label="业务系统是否向云端迁" prop="leaderPersionGropBo.isCloudCorner" label-width="170px">
                                            <el-radio-group v-model="formData.leaderPersionGropBo.isCloudCorner">
                                                <el-radio label="是"></el-radio>
                                                <el-radio label="否"></el-radio>
                                            </el-radio-group>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="有无制造业和工业互联网融合示范项目" prop="leaderPersionGropBo.havCoalesceProject" label-width="270px">
                                            <el-radio-group v-model="formData.leaderPersionGropBo.havCoalesceProject	">
                                                <el-radio label="是"></el-radio>
                                                <el-radio label="否"></el-radio>
                                            </el-radio-group>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row :gutter="20">
                                    <el-col :span="24">
                                        <el-form-item label="核心业务采用信息系统支撑情况(可多选)  " prop="leaderPersionGropBo.coreBusinessSystem" label-width="280px">
                                            <el-checkbox-group v-model="formData.leaderPersionGropBo.coreBusinessSystem" style="width:100%" @change="handleCheckedCitiesChange">
                                                <el-checkbox v-for="ele in coreBusinessSystemArr" :label="ele.dictionariesId" :key="ele.dictionariesId">{{ele.dictMsg}}</el-checkbox>
                                            </el-checkbox-group>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row :gutter="20" v-if="isInput">
                                    <el-col :span="24">
                                        <el-form-item label="核心业务采用信息系统支撑情况其他情况说明  " prop="leaderPersionGropBo.coreBusinessSystemExplain" label-width="300px">
                                            <el-input placeholder="限150字" type="textarea" maxlength="150" show-word-limit :rows="3" v-model="formData.leaderPersionGropBo.coreBusinessSystemExplain"></el-input>
                                        </el-form-item>
                                    </el-col>

                                </el-row>
                                <div class="header">
                                    企业认证情况
                                </div>
                                <el-row :gutter="20">
                                    <el-col :span="12">
                                        <el-form-item label="产品生产执行标准" prop="leaderPersionGropBo.productStandard" label-width="150px">
                                            <el-select v-model="formData.leaderPersionGropBo.productStandard" placeholder="请选择" style="width:100%">
                                                <el-option v-for="ele in productStandardArr" :key="ele.dictionariesId" :label="ele.dictMsg" :value="ele.dictionariesId"></el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="产品获得发达国家或地区权威认证 " prop="leaderPersionGropBo.regionalCertification" label-width="240px">
                                            <el-select v-model="formData.leaderPersionGropBo.regionalCertification" placeholder="请选择" style="width:100%">
                                                <el-option v-for="ele in regionalCertificationArr" :key="ele.dictionariesId" :label="ele.dictMsg" :value="ele.dictionariesId"></el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row :gutter="20">
                                    <el-col :span="12">
                                        <el-form-item label="企业获得的管理体系认证" prop="leaderPersionGropBo.managerCertification" label-width="180px">
                                            <el-select v-model="formData.leaderPersionGropBo.managerCertification" placeholder="请选择" style="width:100%">
                                                <el-option v-for="ele in managerCertificationArr" :key="ele.dictionariesId" :label="ele.dictMsg" :value="ele.dictionariesId"></el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="获得相关部门认定的称号 " prop="leaderPersionGropBo.governmentCertification" label-width="180px">
                                            <el-select v-model="formData.leaderPersionGropBo.governmentCertification" placeholder="请选择" style="width:100%">
                                                <el-option v-for="ele in governmentCertificationArr" :key="ele.dictionariesId" :label="ele.dictMsg" :value="ele.dictionariesId"></el-option>
                                            </el-select>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row :gutter="20" v-if="isGovernment">
                                    <el-col :span="12">
                                        <el-form-item label="其他称号说明" prop="leaderPersionGropBo.governmentCertificationExplain" label-width="180px">
                                            <el-input placeholder="请输入" v-model="formData.leaderPersionGropBo.governmentCertificationExplain"></el-input>
                                        </el-form-item>
                                    </el-col>

                                </el-row>
                                <div class="header">
                                    社会职务
                                    <span class="education">(请列出你所担任的社会职务或其他兼职，如人大代表、政协委员，或在协会团体中担任的职务)</span>
                                </div>
                                <div v-for="(item,
                                    index) in formData.leaderPostionBoS" :key="index" style="margin-bottom:10px; " shadow="never">
                                    <el-row style="marginLeft:30px">
                                        <el-col :span="7">
                                            <el-form-item label="团体" :prop="'leaderPostionBoS.'+ index +'.positionGroup'" :rules="formRules.positionGroup" label-width="80px">
                                                <el-input placeholder="请输入团体" v-model="formData.leaderPostionBoS[index].positionGroup"></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="1">
                                            <div style="marginRight:10px;color:#fff">&nbsp</div>
                                        </el-col>
                                        <el-col :span="7">
                                            <el-form-item label="参加时间" :prop="'leaderPostionBoS.'+ index +'.joinTime'" :rules="formRules.joinTime" label-width="90px">
                                                <el-date-picker v-model="formData.leaderPostionBoS[index].joinTime" type="date" format="yyyy-MM-dd" value-format="yyyy-MM-dd"
                                                    placeholder="选择日期" style="width:100%">
                                                </el-date-picker>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="1">
                                            <div style="marginRight:10px;color:#fff">&nbsp</div>
                                        </el-col>
                                        <el-col :span="7">
                                            <el-form-item label="职务" :prop="'leaderPostionBoS.'+ index +'.position'" :rules="formRules.position" label-width="80px">
                                                <el-input placeholder="请输入职务" v-model="formData.leaderPostionBoS[index].position"></el-input>
                                            </el-form-item>
                                        </el-col>
                                        <el-col :span="1">
                                            <i class="el-icon-remove-outline deteleIcon" @click.prevent="removeDomain(item)" v-if="index>0" />
                                        </el-col>
                                    </el-row>
                                </div>
                                <div class="btnwarp">
                                    <div @click="addDomain" class="addbtn">
                                        <i class="el-icon-circle-plus-outline" /> 增加</div>
                                </div>
                                <div class="header honor">企业荣誉和奖励
                                </div>
                                <el-row :gutter="20">
                                    <el-col :span="24">
                                        <el-form-item label="" prop="leaderPersionGropBo.honor">
                                            <el-input placeholder="请输入" type="textarea" :rows="6" v-model="formData.leaderPersionGropBo.honor"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <div class="header">
                                    企业简介
                                    <span class="education">(企业总体情况简要介绍，主要说明主导产品的技术先进性、市场占有份额、发展前景等，800字以内)</span>
                                </div>
                                <el-row :gutter="20">
                                    <el-col :span="24">
                                        <el-form-item label="" prop="leaderPersionGropBo.companyIntro">
                                            <el-input placeholder="（请说明）" type="textarea" maxlength="800" :rows="4" v-model="formData.leaderPersionGropBo.companyIntro"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </div>
                        </div>
                        <!-- <div class="makeoutInfoBox">
                            <div class="header">开票信息
                            </div>
                            <el-row :gutter="20">
                                <el-col :span="12">
                                    <el-form-item label="单位名称" prop="busBillInfoBo.corpName">
                                        <el-input placeholder="请输入单位名称" v-model="formData.busBillInfoBo.corpName"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="单位税号" prop="busBillInfoBo.organizingCord">
                                        <el-input placeholder="请输入单位税号" v-model="formData.busBillInfoBo.organizingCord"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row :gutter="20">
                                <el-col :span="12">
                                    <el-form-item label="单位性质" prop="busBillInfoBo.billnature">
                                        <el-radio-group v-model="formData.busBillInfoBo.billnature" @change="billnatureFn">
                                            <el-radio label="小规模纳税人"></el-radio>
                                            <el-radio label="一般纳税人"></el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="开票种类" prop="busBillInfoBo.billkind">
                                        <el-radio-group v-model="formData.busBillInfoBo.billkind" @change="billkindFn">
                                            <el-radio label="增值税普通发票"></el-radio>
                                            <el-radio label="增值税专用发票" :disabled="billnatureValue=='小规模纳税人' ? true : false"></el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <div v-if="billnatureValue=='一般纳税人'&&kindVal=='增值税专用发票'">
                                <el-row :gutter="20">
                                    <el-col :span="12">
                                        <el-form-item label="单位电话" prop="busBillInfoBo.billphone">
                                            <el-input placeholder="请输入单位电话" v-model="formData.busBillInfoBo.billphone"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="单位地址" prop="busBillInfoBo.billsite">
                                            <el-input placeholder="请输入单位地址" v-model="formData.busBillInfoBo.billsite"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row :gutter="20">
                                    <el-col :span="12">
                                        <el-form-item label="开户行银行账号" prop="busBillInfoBo.bankName">
                                            <el-input placeholder="请输入开户行银行账号" v-model="formData.busBillInfoBo.bankName"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="开户行银行名称" prop="busBillInfoBo.bankUserName">
                                            <el-input placeholder="请输入开户行银行名称" v-model="formData.busBillInfoBo.bankUserName"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                            </div>
                            <div class="header">收票人信息</div>
                            <el-row :gutter="20">
                                <el-col :span="12">
                                    <el-form-item label="收票人姓名" prop="busBillInfoBo.linkman">
                                        <el-input placeholder="请输入收票人姓名" v-model="formData.busBillInfoBo.linkman"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="收票人手机号" prop="busBillInfoBo.phone">
                                        <el-input placeholder="请输入收票人手机号" v-model="formData.busBillInfoBo.phone"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row :gutter="20">
                                <el-col :span="12">
                                    <el-row :gutter="0">
                                        <el-form-item label="所在地区" prop='busBillInfoBo.area'>
                                            <el-col :span="8">
                                                <el-select v-model="formData.areacity.province" placeholder="省份" @change="areaonProvinces($event)" style="width:100%">
                                                    <el-option v-for="item in ProvinceArr" :key="item.provinceId" :label="item.province" :value="item.province"></el-option>
                                                </el-select>
                                            </el-col>
                                            <el-col :span="8">
                                                <el-select v-model="formData.areacity.town" placeholder="市区" style="width:100%" @change="areaonTowns($event)">
                                                    <el-option v-for="item in CityArr" :key="item.cityId" :label="item.city" :value="item.city"></el-option>
                                                </el-select>
                                            </el-col>
                                            <el-col :span="8">
                                                <el-select v-model="formData.areacity.county" placeholder="区县" style="width:100%" @change="areacountyFn($event)">
                                                    <el-option v-for="item in CountyArr" :key="item.areaId" :label="item.area" :value="item.area"></el-option>
                                                </el-select>
                                            </el-col>
                                        </el-form-item>
                                    </el-row>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="详细地址" prop="busBillInfoBo.acceptSite">
                                        <el-input placeholder="请输入详细地址" v-model="formData.busBillInfoBo.acceptSite"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row :gutter="20">
                                <el-col :span="12">
                                    <el-form-item label="接收邮箱" prop="busBillInfoBo.billemail">
                                        <el-input placeholder="请输入接收邮箱" v-model="formData.busBillInfoBo.billemail"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                             <el-row :gutter="20">
                                <el-col :span="12">
                                   <el-form-item label="缴费凭证" prop="busBillInfoBo.payMentVoucher">
                                <el-upload id="payupload" ref="payupload"  accept=".jpg,.png,.jpeg" list-type="picture-card" :on-success="handleAvatarSuccess" :on-remove="handleRemove"
                                    :action="actionUrl" :headers="header" :limit="1" :file-list="payfileList">
                                    <i class="el-icon-plus"></i>
                                </el-upload>
                            </el-form-item>
                                </el-col>
                            </el-row>
                        </div> -->
                        <div class="fileBox">
                            <div class="header">报名表信息</div>
                        </div>
                        <div class="makeoutInfoBox">

                            <!-- <el-row :gutter="20">
                                <el-col :span="12">
                                    <div class="textbox" @click="downloadRecommendFn">
                                        <span>查看</span>下载领军人才学员选拔表
                                        <i class="el-icon-download iconbox" />
                                    </div>
                                </el-col>
                                <el-col :span="12">
                                    <div class="textbox" @click="downloadFileFn">
                                        <span>查看</span>下载领军人才推荐信
                                        <i class="el-icon-download iconbox" />
                                    </div>
                                </el-col>
                            </el-row> -->
                            <el-row :gutter="20">
                                <el-col :span="12">
                                    <div class="textbox">
                                        <div class="leftbox"><img class="imgbox" src="@/assets/imgs/lead/file.png">
                                            <span>《选拔表》</span>
                                        </div>
                                        <div class="downBox" @click="downloadRecommendFn">下载</div>
                                    </div>
                                </el-col>
                                <el-col :span="12">
                                    <div class="textbox">
                                        <div class="leftbox"><img class="imgbox" src="@/assets/imgs/lead/file.png">
                                            <span>《推荐信》</span>
                                        </div>
                                        <div class="downBox" @click="downloadFileFn">下载</div>
                                    </div>
                                </el-col>
                            </el-row>
                            <el-row :gutter="20">
                                <el-col :span="12">
                                    <el-form-item label="1.学员选拔表" prop="selectinfo">
                                        <el-upload id="imgupload" ref="imgupload" accept=".jpg,.png,.jpeg" list-type="picture-card" :on-success="handleAvatarSuccess"
                                            :on-remove="handleRemove" :action="actionUrl" :headers="header" :limit="1" :file-list="imgfileList">
                                            <i class="el-icon-plus"></i>
                                        </el-upload>
                                    </el-form-item>
                                    <!-- <div class="imgtitlebox">1.学员选拔表</div>
                                <div v-for="(item,index) in imgfileList" :key="index" class="imgwarp">
                                    <img :src='item.url' class="singeimgbox" />
                                </div> -->
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="2.推荐信扫描件" prop="nominate">
                                        <el-upload id="letterupload" accept=".jpg,.png,.jpeg" list-type="picture-card" :on-success="letterSuccess" :on-remove="letterRemove"
                                            :action="actionUrl" :headers="header" :limit="1" :file-list="letterfileList">
                                            <i class="el-icon-plus"></i>
                                        </el-upload>

                                    </el-form-item>
                                    <!-- <div class="imgtitlebox">2.推荐信扫描件</div>
                                <div v-for="(item,index) in letterfileList" :key="index" class="imgwarp">
                                    <img :src='item.url' class="singeimgbox" />

                                </div> -->
                                </el-col>
                            </el-row>
                            <!-- <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item label="3.电子版照片" prop="peopleImg">
                                    <el-upload accept=".jpg,.png,.jpeg" id="peopleimgupload" list-type="picture-card" :on-success="secondSuccessFn" :on-remove="secondRemoveFn"
                                        :action="actionUrl" :headers="header" :file-list="secondfileList">
                                        <i class="el-icon-plus"></i>
                                    </el-upload>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item label="4.报名视频" prop="video" class="videoFormItem">
                                    <div class="videoText">
                                        <el-popover placement="top-start" title="视频要求:" width="550" trigger="hover">
                                            <div>
                                                <h4>（一）内容要求</h4>
                                                <p>1.个人简介（建议介绍学历、工作经验、获得奖励情况等）；</p>
                                                <p>2.所在企业简介（建议介绍企业规模、服务人数、产品创新、企业优势、获得荣誉等）；</p>
                                                <p>3.为什么参加本期“领军人才”培训。</p>
                                                <h4>（二）技术要求</h4>
                                                <p>1.视频时长：2分钟以内；</p>
                                                <p>2.分辨率和帧率:1920*1080p或者4k帧率25fps ；</p>
                                                <p>3.构图：横屏16:9，主要取景为人体膝盖以上或上半身；</p>
                                                <p>4.格式：录mp4格式，h.264或者h.265，根据具体情况确定1920X1080或者4K分辨率；</p>
                                                <p>5.场地：保证无杂音，视频背景简单大方，建议不要选择白墙做背景；</p>
                                                <p>6.其他：建议着正装，声音洪亮、吐字清晰。</p>
                                            </div>
                                            <div slot="reference">(视频要求)</div>
                                        </el-popover>
                                    </div>
                                    <el-upload v-if="thirdfileList.length==0" id="uploadmedia" accept=".mp4,.ogg,.flv,.avi,.wmv,.rmvb" list-type="picture-card"
                                        :on-success="thirdSuccessFn" :on-remove="thirdRemoveFn" :action="actionUrl" :file-list="thirdfileList"
                                        :headers="header">
                                        <i class="el-icon-plus"></i>
                                    </el-upload>
                                    <div v-else>
                                        <div class="imgwarp">
                                            <video id="media" :src="videoUrl+videodata" controls width="320px" heigt="200px"></video>
                                            <span class="spanbox" @click="deleteVideo">
                                                <i class="el-icon-delete-solid videoicon" />
                                            </span>
                                        </div>
                                    </div>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item label="5.其它文件上传">
                                    <el-upload multiple :on-success="handlefileSuccess" :on-remove="handlefileRemove" :action="actionUrl" :headers="header" :file-list="fileList">
                                        <i class="el-icon-upload upicon"></i>
                                    </el-upload>
                                </el-form-item>
                            </el-col>
                        </el-row> -->
                        </div>
                    </div>
                    <!-- 开票 -->
                    <div v-if="billAudit==1">
                        <div class="makeoutInfoBox">
                            <div class="header">开票信息
                            </div>
                            <el-row :gutter="20">
                                <el-col :span="12">
                                    <el-form-item label="单位名称" prop="busBillInfoBo.corpName">
                                        <el-input placeholder="请输入单位名称" v-model="formData.busBillInfoBo.corpName"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="单位税号" prop="busBillInfoBo.organizingCord">
                                        <el-input placeholder="请输入单位税号" v-model="formData.busBillInfoBo.organizingCord"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row :gutter="20">
                                <el-col :span="12">
                                    <el-form-item label="单位性质" prop="busBillInfoBo.billnature">
                                        <el-radio-group v-model="formData.busBillInfoBo.billnature" @change="billnatureFn">
                                            <el-radio label="小规模纳税人"></el-radio>
                                            <el-radio label="一般纳税人"></el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="开票种类" prop="busBillInfoBo.billkind">
                                        <el-radio-group v-model="formData.busBillInfoBo.billkind" @change="billkindFn">
                                            <el-radio label="增值税普通发票"></el-radio>
                                            <el-radio label="增值税专用发票" :disabled="billnatureValue=='小规模纳税人' ? true : false"></el-radio>
                                        </el-radio-group>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <div v-if="billnatureValue=='一般纳税人'&&kindVal=='增值税专用发票'">
                                <el-row :gutter="20">
                                    <el-col :span="12">
                                        <el-form-item label="单位电话" prop="busBillInfoBo.billphone">
                                            <el-input placeholder="请输入单位电话" v-model="formData.busBillInfoBo.billphone"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="单位地址" prop="busBillInfoBo.billsite">
                                            <el-input placeholder="请输入单位地址" v-model="formData.busBillInfoBo.billsite"></el-input>
                                        </el-form-item>
                                    </el-col>
                                </el-row>
                                <el-row :gutter="20">
                                    <el-col :span="12">
                                        <el-form-item label="开户行银行名称" prop="busBillInfoBo.bankUserName">
                                            <el-input placeholder="请输入开户行银行名称" v-model="formData.busBillInfoBo.bankUserName"></el-input>
                                        </el-form-item>
                                    </el-col>
                                    <el-col :span="12">
                                        <el-form-item label="开户行银行账号" prop="busBillInfoBo.bankName">
                                            <el-input placeholder="请输入开户行银行账号" v-model="formData.busBillInfoBo.bankName"></el-input>
                                        </el-form-item>
                                    </el-col>

                                </el-row>
                            </div>
                            <div class="header">收票人信息</div>
                            <el-row :gutter="20">
                                <el-col :span="12">
                                    <el-form-item label="收票人姓名" prop="busBillInfoBo.linkman">
                                        <el-input placeholder="请输入收票人姓名" v-model="formData.busBillInfoBo.linkman"></el-input>
                                    </el-form-item>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="收票人手机号" prop="busBillInfoBo.phone">
                                        <el-input placeholder="请输入收票人手机号" v-model="formData.busBillInfoBo.phone"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row :gutter="20">
                                <el-col :span="12">
                                    <el-row :gutter="0">
                                        <el-form-item label="所在地区" prop='busBillInfoBo.area'>
                                            <el-col :span="8">
                                                <el-select v-model="formData.areacity.province" placeholder="省份" @change="areaonProvinces($event)" style="width:100%">
                                                    <el-option v-for="item in ProvinceArr" :key="item.provinceId" :label="item.province" :value="item.province"></el-option>
                                                </el-select>
                                            </el-col>
                                            <el-col :span="8">
                                                <el-select v-model="formData.areacity.town" placeholder="市区" style="width:100%" @change="areaonTowns($event)">
                                                    <el-option v-for="item in CityArr" :key="item.cityId" :label="item.city" :value="item.city"></el-option>
                                                </el-select>
                                            </el-col>
                                            <el-col :span="8">
                                                <el-select v-model="formData.areacity.county" placeholder="区县" style="width:100%" @change="areacountyFn($event)">
                                                    <el-option v-for="item in CountyArr" :key="item.areaId" :label="item.area" :value="item.area"></el-option>
                                                </el-select>
                                            </el-col>
                                        </el-form-item>
                                    </el-row>
                                </el-col>
                                <el-col :span="12">
                                    <el-form-item label="详细地址" prop="busBillInfoBo.acceptSite">
                                        <el-input placeholder="请输入详细地址" v-model="formData.busBillInfoBo.acceptSite"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row :gutter="20">
                                <el-col :span="12">
                                    <el-form-item label="接收邮箱" prop="busBillInfoBo.billemail">
                                        <el-input placeholder="请输入接收邮箱" v-model="formData.busBillInfoBo.billemail"></el-input>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                            <el-row :gutter="20">
                                <el-col :span="12">
                                    <el-form-item label="缴费凭证" prop="busBillInfoBo.payMentVoucher">
                                        <el-upload id="payupload" ref="payupload" accept=".jpg,.png,.jpeg" list-type="picture-card" :on-success="handleAvatarSuccess"
                                            :on-remove="handleRemove" :action="actionUrl" :headers="header" :limit="1" :file-list="payfileList">
                                            <i class="el-icon-plus"></i>
                                        </el-upload>
                                    </el-form-item>
                                </el-col>
                            </el-row>
                        </div>
                    </div>
                    <div class="formBtnBox">
                        <!-- <el-button type="primary" @click="fileSubmitFN" v-if="auditResult==3&&downloadFlag" class="submitBtn" :loading="isloading">提交</el-button>
                        <el-button type="primary" @click="submitForm('formData')" v-if="auditResult==3&&!downloadFlag" class="submitBtn" :loading="isloading">提交</el-button> -->
                        <!-- <el-button @click="submitdraft" class="cancelBtn">取消报名</el-button> -->
                        <el-button type="primary" @click="submitForm('formData')" v-if="auditResult==98||auditResult==3||auditResult==199||auditResult==100"
                            class="submitBtn" :loading="isloading">提交</el-button>
                        <el-button @click="returnListFn" class="returnBtn">返回</el-button>
                    </div>

                </el-form>

            </div>
        </div>
    </div>
</template>
<script>
import { httpService, srcUrl, videoUrl } from "@/service/httpService";
export default {
    data() {
        return {
            // 报名表单
            formData: {
                // 个人
                userName: null,
                sex: null,
                ethnic: null,
                birthDay: null,
                cardId: null,
                politics: null,
                post: null,
                manageList: null,
                // phone: null,
                // telPhone: null,
                email: null,
                address: null,
                school: null,
                times: null,
                major: null,
                education: null,
                // city: { // 地区联动
                //     province: null,
                //     town: null,
                // },
                // // 开票所在地区
                // areacity: {
                //     province: null,
                //     town: null,
                //     county: null,
                // },
                honor: null,//个人荣誉与奖励
                // 企业
                leaderPersionGropBo: {
                    name: null,
                    address: null,
                    website: null,
                    industry: null,
                    listed: null,
                    party: null,
                    leaderReason: [],
                    companyIntro: null,
                    personIntro: null,
                    honor: null,
                    // 资产
                    propertyBo: {
                        yesterassets: null,
                        yetersale: null,
                        yesterstaffNum: null,
                        yestergrowth: null,
                        beforeassets: null,
                        beforesale: null,
                        beforestaffNum: null,
                        beforegrowth: null
                    },
                    // 上市
                    beforeList: null,//未来三年是否有上市计划（1有 2无）
                    listProcess: null,//上市进程（1未股改 2已股改 3提交申请）
                    listPlate: null,//拟上市板块(1上交所主板 2上交所科创板 3深交所主板 4深交所创业板 5北交所)
                    industryDetails: null,//	行业具体细分领域
                    corpType: null,//	企业类型（1国有 2合资 3民营 4其他）
                    organizingCord: null,//	企业组织机构代码
                    leadingProduct: null,//	主导产品名称
                    leadingProductType: null,//	主导产品类别
                    leadingProductYear: null,//	主导产品时间
                    leadingProductProportion: null,//	主营业务收入占营业收入比重
                    patentNum: null,//	专利数量
                    patent1: null,//	发明专利数量
                    patent2: null,//	植物新品种
                    patent3: null,//国家级农作物品种数量
                    patent4: null,//	国家新药数量
                    patent5: null,//	集成电路布图设计专有权数量
                    isDirectMating: null,//	是否为国内外知名大企业直接配套
                    directMatingNames: null,//	配套相关产品
                    isCloudCorner: null,//	业务系统是否向云端迁移(1有 2无)
                    havCoalesceProject: null,//	有无制造业和工业互联网融合示范项目(1有 2无)
                    coreBusinessSystem: [],//	核心业务采用信息系统支撑情况
                    coreBusinessSystemExplain: null,//	核心业务采用信息系统支撑情况-其他说明
                    productStandard: null,//	产品生产执行标准
                    regionalCertification: null,//	产品获得发达国家或地区权威认证
                    managerCertification: null,//	企业获得的管理体系认证
                    governmentCertification: null,//	获得相关部门认定的称号
                    governmentCertificationExplain: null,//	获得相关部门认定的称号-其他说明
                },
                // 社会职务
                // leaderPostionBoS: [{
                //     positionGroup: null,
                //     joinTime: null,
                //     position: null
                // }],
            },
            formRules: {
                userName: [
                    { required: true, message: '姓名不能为空', trigger: 'blur' }
                ],
                sex: [
                    { required: true, message: '性别不能为空', trigger: 'blur' }
                ],
                ethnic: [
                    { required: true, message: '民族不能为空', trigger: 'blur' }
                ],
                birthDay: [
                    { required: true, message: '请选择日期', trigger: 'change' }
                ],
                cardId: [
                    { required: true, message: '请输入正确的身份证号码', pattern: /^[1-9]\d{5}(18|19|([23]\d))\d{2}((0[1-9])|(10|11|12))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/, trigger: 'blur' }
                ],
                politics: [
                    { required: true, message: '政治面貌不能为空', trigger: 'blur' }
                ],
                post: [
                    { required: true, message: '现任职务不能为空', trigger: 'blur' }
                ],
                manageList: [
                    { required: true, message: '管理经验年限不能为空', trigger: 'blur' }
                ],
                phone: [
                    {
                        required: true, message: '手机号码不能为空', trigger: 'blur'
                    },
                    {
                        required: true, message: '请输入正确的手机号码', pattern: /^1[3|4|5|7|8][0-9]\d{8}$/, trigger: 'blur'
                    }
                ],
                // telPhone: [
                //     {
                //         required: true, message: '办公电话不能为空', trigger: 'blur'
                //     }
                // ],
                'email': [
                    { required: true, message: '请输入邮箱地址', trigger: 'blur' },
                    { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
                ],
                'address': [
                    {
                        required: true, message: '通讯地址不能为空', trigger: 'blur'
                    }
                ],
                'school': [
                    {
                        required: true, message: '毕业院校不能为空', trigger: 'blur'
                    }
                ],
                'times': [
                    { required: true, message: '请选择起止日期', trigger: 'change' }
                ],
                'major': [
                    {
                        required: true, message: '专业不能为空', trigger: 'blur'
                    }
                ],
                'education': [
                    {
                        required: true, message: '学历/学位 不能为空', trigger: 'blur'
                    }
                ],
                // 'leaderPersionGropBo.website': [
                //     {
                //         required: true, message: '公司网址不能为空', trigger: 'blur'
                //     }
                // ],
                'leaderPersionGropBo.industry': [
                    {
                        required: true, message: '所属行业不能为空', trigger: 'blur'
                    }
                ],

                'leaderPersionGropBo.name': [
                    {
                        required: true, message: '企业名称不能为空', trigger: 'blur'
                    }
                ],
                'leaderPersionGropBo.address': [
                    { required: true, message: '请选择所在区域', trigger: 'change' }
                ],

                'leaderPersionGropBo.listed': [
                    { required: true, message: '请选择是否上市 ', trigger: 'change' }
                ],
                'leaderPersionGropBo.party': [
                    { required: true, message: '请选择是否设立党组织 ', trigger: 'change' }
                ],
                'leaderPersionGropBo.leaderReason': [
                    // { required: true, message: '请至少选择一个', trigger: 'change' }
                    { type: 'array', required: true, message: '请至少选择一个', trigger: 'change' }
                ],
                'leaderPersionGropBo.propertyBo.yesterassets': [
                    { required: true, message: ' 请输入资产总额', trigger: 'blur' }
                ],
                'leaderPersionGropBo.propertyBo.yetersale': [
                    { required: true, message: ' 请输入年销售额', trigger: 'blur' }
                ],
                'leaderPersionGropBo.propertyBo.yesterstaffNum': [
                    { required: true, message: ' 请输入员工人数', trigger: 'blur' }
                ],
                'leaderPersionGropBo.propertyBo.yestergrowth': [
                    { required: true, message: ' 请输入年利润增长率（与上一年比较）', trigger: 'blur' }
                ],
                'leaderPersionGropBo.propertyBo.beforeassets': [
                    { required: true, message: ' 请输入资产总额', trigger: 'blur' }
                ],
                'leaderPersionGropBo.propertyBo.beforesale': [
                    { required: true, message: ' 请输入年销售额', trigger: 'blur' }
                ],
                'leaderPersionGropBo.propertyBo.beforestaffNum': [
                    { required: true, message: ' 请输入员工人数', trigger: 'blur' }
                ],
                'leaderPersionGropBo.propertyBo.beforegrowth': [
                    { required: true, message: ' 请输入年利润增长率（与上一年比较）', trigger: 'blur' }
                ],
                'leaderPersionGropBo.companyIntro': [
                    { required: true, message: ' 请输入企业简介', trigger: 'blur' },
                    { max: 150, message: '请控制在150个字符以内', trigger: 'blur' }
                ],
                'leaderPersionGropBo.personIntro': [
                    { required: true, message: ' 请输入个人简介', trigger: 'blur' },
                    { max: 150, message: '请控制在150个字符以内', trigger: 'blur' }
                ],
                // positionGroup: [
                //     { required: true, message: ' 请输入团体 ', trigger: 'blur' }
                // ],
                // joinTime: [
                //     { required: true, message: ' 请输入参加时间 ', trigger: 'change' }
                // ],
                // position: [
                //     { required: true, message: ' 请输入职务 ', trigger: 'blur' }
                // ],
                // 'leaderPersionGropBo.honor': [
                //     { required: true, message: ' 请输入荣誉和奖励', trigger: 'blur' }
                // ],
                'busBillInfoBo.corpName': [
                    { required: true, message: '单位名称不能为空', trigger: 'blur' }
                ],
                'busBillInfoBo.organizingCord': [
                    { required: true, message: '单位税号不能为空', trigger: 'blur' }
                ],
                'busBillInfoBo.billnature': [
                    { required: true, message: '请选择单位性质', trigger: 'change' }
                ],
                'busBillInfoBo.billkind': [
                    { required: true, message: '请选择开票种类', trigger: 'change' }
                ],
                'busBillInfoBo.billsite': [
                    {
                        required: true,
                        message: '请输入单位地址', trigger: 'blur'
                    },
                ],
                'busBillInfoBo.billphone': [
                    {
                        required: true,
                        message: '请输入单位电话', trigger: 'blur',

                    },
                    // { pattern: /^1[3|4|5|7|8][0-9]\d{8}$/, trigger: 'blur', message: '请输入正确的联系人手机号码', }
                ],
                'busBillInfoBo.bankName': [
                    {
                        required: true,
                        message: '请输入开户银行名称', trigger: 'blur'
                    },
                ],
                'busBillInfoBo.bankUserName': [
                    {
                        required: true,
                        message: '请输入开户银行账号', trigger: 'blur'
                    },
                ],
                'busBillInfoBo.billemail': [
                    { required: true, message: '请输入邮箱地址', trigger: 'blur' },
                    { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
                ],
                'busBillInfoBo.linkman': [
                    { required: true, message: '请输入姓名', trigger: 'blur' },
                ],
                'busBillInfoBo.phone': [
                    { required: true, message: '请输入手机号', trigger: 'blur' },
                    { pattern: /^1[3|4|5|7|8][0-9]\d{8}$/, trigger: 'blur', message: '请输入正确的手机号码', }
                ],
                'busBillInfoBo.acceptSite': [
                    { required: true, message: '请输入详细地址', trigger: 'blur' },
                ],
                'busBillInfoBo.area': [
                    { required: true, message: '请选择地区', trigger: 'change' }
                ],
                'busBillInfoBo.payMentVoucher': [
                    { required: true, message: '请上传', trigger: 'change' }
                ],



            },
            singupserialNumber: 1,
            showdelete: false,
            kindVal: null,
            billnatureValue: null,
            selectVal: null,
            newyear: '',
            nextyear: '',
            ProvinceArr: [],//省
            addressProvinceArr: [],
            CityArr: [],//市
            addressCityArr: [],
            CountyArr: [],
            politicsArr: [],//政治面貌
            nationArr: [],//民族
            educationArr: [],//学历
            // 新增
            listPlateArr: [],//上市板块
            listProcessArr: [],//上市进程
            corpTypeArr: [],//企业类型
            coreBusinessSystemArr: [],//核心业务采用信息系统支撑情况
            productStandardArr: [],//产品生产执行标准
            regionalCertificationArr: [],//产品获得发达国家或地区权威认证
            managerCertificationArr: [],//企业获得的管理体系认证
            governmentCertificationArr: [],//获得相关部门认定的称号
            leadReasonArr: [],//领军人才理由
            sexArr: [],//性别

            srcUrl: srcUrl,
            videoUrl: videoUrl,
            // 文件相关
            actionUrl: process.env.VUE_APP_GATEWAY + '/upload/addfile',
            header: null,
            imgfileList: [],
            letterfileList: [],
            secondfileList: [],
            thirdfileList: [],
            fileList: [],//其他文件
            videodata: '',
            trainCourse: '',
            leaderPersonId: '',
            trainCode: '',
            downloadFlag: false,
            auditResult: -1,
            isloading: false,
            isListed: false,// 是否上市
            isListingPlan: false,//有无上市计划
            isMating: false,//是否配套
            isInput: false,//其他
            isGovernment: false,
            downText: '选拔表',
            studentTableUrl: '',
            recommendLetter: '',
            billAudit: null,
            payfileList: [],
        }
    },
    created() {
        // 获取当前年的前2年
        let date = new Date();
        this.newyear = date.getFullYear() - 1
        this.nextyear = date.getFullYear() - 2
        // this.trainCourse = this.$route.query.trainCourse 
        // this.trainCode = this.$route.query.trainCode 
        this.leaderPersonId = this.$route.query.id
        this.billAudit = this.$route.query.billAudit
    },
    mounted() {
        // 获取省的数据
        this.getProvinceFn()
        // 数据字典
        this.dataDictionaryFn()
        // 回填表单
        this.getyetFormFn()
    },
    methods: {
        dataDictionaryFn() {
            // 政治面貌
            let p1 = new Promise((resolve, reject) => {
                httpService.dataDictionary({ params: { fieldName: 'politics' } })
                    .then(res => {
                        resolve(res);
                    })
                    .catch(err => {
                        reject(err);
                    });
            })
            // 民族
            let p2 = new Promise((resolve, reject) => {
                httpService.dataDictionary({ params: { fieldName: 'nation' } })
                    .then(res => {
                        resolve(res);
                    })
                    .catch(err => {
                        reject(err);
                    });
            })
            // 学历education
            let p3 = new Promise((resolve, reject) => {
                httpService.dataDictionary({ params: { fieldName: 'education' } })
                    .then(res => {
                        resolve(res);
                    })
                    .catch(err => {
                        reject(err);
                    });
            })

            // 性别 sex
            let p4 = new Promise((resolve, reject) => {
                httpService.dataDictionary({ params: { fieldName: 'sex' } })
                    .then(res => {
                        resolve(res);
                    })
                    .catch(err => {
                        reject(err);
                    });
            })
            // 上市板块listPlateArr
            let p5 = new Promise((resolve, reject) => {
                httpService.dataDictionary({ params: { fieldName: 'listPlate' } })
                    .then(res => {
                        resolve(res);
                    })
                    .catch(err => {
                        reject(err);
                    });
            })
            // 上市进程
            let p6 = new Promise((resolve, reject) => {
                httpService.dataDictionary({ params: { fieldName: 'listProcess' } })
                    .then(res => {
                        resolve(res);
                    })
                    .catch(err => {
                        reject(err);
                    });
            })
            //  corpTypeArr,//企业类型
            let p7 = new Promise((resolve, reject) => {
                httpService.dataDictionary({ params: { fieldName: 'corpType' } })
                    .then(res => {
                        resolve(res);
                    })
                    .catch(err => {
                        reject(err);
                    });
            })

            // coreBusinessSystemArr:[],//核心业务采用信息系统支撑情况
            let p8 = new Promise((resolve, reject) => {
                httpService.dataDictionary({ params: { fieldName: 'coreBusinessSystem' } })
                    .then(res => {
                        resolve(res);
                    })
                    .catch(err => {
                        reject(err);
                    });
            })
            // productStandardArr:[],//产品生产执行标准
            let p9 = new Promise((resolve, reject) => {
                httpService.dataDictionary({ params: { fieldName: 'productStandard' } })
                    .then(res => {
                        resolve(res);
                    })
                    .catch(err => {
                        reject(err);
                    });
            })
            // regionalCertificationArr:[],//产品获得发达国家或地区权威认证
            let p10 = new Promise((resolve, reject) => {
                httpService.dataDictionary({ params: { fieldName: 'regionalCertification' } })
                    .then(res => {
                        resolve(res);
                    })
                    .catch(err => {
                        reject(err);
                    });
            })
            // managerCertificationArr:[],//企业获得的管理体系认证
            let p11 = new Promise((resolve, reject) => {
                httpService.dataDictionary({ params: { fieldName: 'managerCertification' } })
                    .then(res => {
                        resolve(res);
                    })
                    .catch(err => {
                        reject(err);
                    });
            })
            // governmentCertificationArr:[],//获得相关部门认定的称号
            let p12 = new Promise((resolve, reject) => {
                httpService.dataDictionary({ params: { fieldName: 'governmentCertification' } })
                    .then(res => {
                        resolve(res);
                    })
                    .catch(err => {
                        reject(err);
                    });
            })


            Promise.all([p1, p2, p3, p4, p5, p6, p7, p8, p9, p10, p11, p12]).then(res => {
                if (res) {
                    this.politicsArr = res[0].result;
                    this.nationArr = res[1].result;
                    this.educationArr = res[2].result;
                    this.sexArr = res[3].result;
                    this.listPlateArr = res[4].result;
                    this.listProcessArr = res[5].result;//上市进程
                    this.corpTypeArr = res[6].result;//企业类型
                    this.coreBusinessSystemArr = res[7].result;//核心业务采用信息系统支撑情况
                    this.productStandardArr = res[8].result;//产品生产执行标准
                    this.regionalCertificationArr = res[9].result;//产品获得发达国家或地区权威认证
                    this.managerCertificationArr = res[10].result;//企业获得的管理体系认证
                    this.governmentCertificationArr = res[11].result;//获得相关部门认定的称号

                }
            })
        },
        // 省市县
        getProvinceFn() {
            httpService.getProvince().then(res => {
                if (res.code == 200) {
                    this.ProvinceArr = res.result
                    this.addressProvinceArr = res.result
                }
            })
        },
        // 选择省
        onProvinces(event) {
            let provinceId
            this.addressProvinceArr.map(item => {
                if (event === item.province) {
                    return provinceId = item.provinceId
                }
            })
            // 改变省之后市变化
            this.formData.city.town = '';
            this.getCityData(provinceId)
        },
        // 获取市
        getCityData(provinceId) {
            //  city: { // 地区联动
            //         province: null,
            //         town: null,
            //     },

            httpService.getCity(provinceId).then(res => {
                if (res.code == 200) {
                    this.addressCityArr = res.result
                }
            })
        },
        // 选择市
        onTowns(event) {
            this.formData.leaderPersionGropBo.address = `${this.formData.city.province},${this.formData.city.town}`
        },
        // 开票所在地区
        // 选择省
        areaonProvinces(event) {
            let provinceId
            this.ProvinceArr.map(item => {
                if (event === item.province) {
                    return provinceId = item.provinceId
                }
            })
            // 改变省之后市变化
            this.formData.areacity.town = '';
            this.formData.areacity.county = '';
            this.getareaCityData(provinceId)
        },
        // 获取市
        getareaCityData(provinceId) {
            httpService.getCity(provinceId).then(res => {
                if (res.code == 200) {
                    this.CityArr = res.result
                    // 回显地址
                    if (this.formData.areacity.county) {
                        let cityId
                        this.CityArr.map(item => {
                            if (item.city === this.formData.areacity.town) {
                                return cityId = item.cityId
                            }
                        })
                        this.getCountyData(cityId)
                    }
                }
            })
        },
        // 选择市
        areaonTowns(event) {
            let cityId
            this.CityArr.map(item => {
                if (event === item.city) {
                    return cityId = item.cityId
                }
            })
            this.formData.areacity.county = '';
            this.getCountyData(cityId)
        },
        getCountyData(cityId) {
            httpService.getArea(cityId).then(res => {
                if (res.code == 200) {
                    this.CountyArr = res.result
                }
            })
        },
        // 选择区
        areacountyFn(event) {
            this.formData.busBillInfoBo.area = `${this.formData.areacity.province},${this.formData.areacity.town},${this.formData.areacity.county}`
        },
        // 是否上市
        changeSsFn(value) {

            this.isListed = value === '否';
            this.isListingPlan = false; // 先设置默认值
            if (this.isListed && this.formData.leaderPersionGropBo.beforeList === '有') {
                this.isListingPlan = true; // 当满足条件时覆盖默认值
            }
        },
        // 是否有上市计划
        changeSsjhFn(value) {
            this.isListingPlan = value === '有';
        },
        //是否配套
        changeMating(value) {
            this.isMating = value === '是';
        },
        // 多选
        handleCheckedCitiesChange(value) {
            if (value.includes('382')) {
                this.isInput = true;
            } else {
                this.isInput = false;
            }
        },
        // 称号
        changeSelectFn(value) {
            this.isGovernment = value == 410;
        },
        // 回填表单
        getyetFormFn() {
            // httpService.getSingleLeaderTalen()
            httpService.GoosegetSingleLeaderTalenById(this.leaderPersonId).then(res => {
                if (res.code == 200) {
                    // console.log(res.result,'res.result');
                    this.trainCourse = res.result.trainCourse
                    this.trainCode = res.result.trainCode
                    this.auditResult = res.result.auditResult
                    // delete res.result.leaderResourceWayVo
                    res.result.city = {
                        province: '',
                        town: '',
                    }
                    res.result.areacity = {
                        province: '',
                        town: '',
                        county: '',
                    }
                    if (res.result.leaderPersionGropVo) {
                        if (res.result.leaderPersionGropVo.address) {
                            res.result.leaderPersionGropVo.address = res.result.leaderPersionGropVo.address.split(',')
                            res.result.city.province = res.result.leaderPersionGropVo.address[0]
                            res.result.city.town = res.result.leaderPersionGropVo.address[1]
                        } else {
                            res.result.city.province = '';
                            res.result.city.town = '';
                        }
                        // 转领军理由
                        // 转领军理由
                        if (res.result.leaderPersionGropVo.coreBusinessSystem) {
                            res.result.leaderPersionGropVo.coreBusinessSystem = res.result.leaderPersionGropVo.coreBusinessSystem.split(',')
                            if (res.result.leaderPersionGropVo.coreBusinessSystem.includes('382')) {
                                this.isInput = true;
                            }
                        } else {
                            res.result.leaderPersionGropVo.coreBusinessSystem = []
                        }
                        // 资产
                        // res.result.leaderPersionGropVo.propertyBo = res.result.leaderPersionGropVo.propertyVoo
                        // 企业
                        res.result.leaderPersionGropBo = res.result.leaderPersionGropVo
                        if (res.result.leaderPersionGropVo.propertyVoo) {
                            res.result.leaderPersionGropVo.propertyBo = res.result.leaderPersionGropVo.propertyVoo
                        } else {
                            res.result.leaderPersionGropVo.propertyBo = {
                                yesterassets: '',
                                yetersale: '',
                                yesterstaffNum: '',
                                yestergrowth: '',
                                beforeassets: '',
                                beforesale: '',
                                beforestaffNum: '',
                                beforegrowth: ''
                            }
                        }
                    }
                    else {
                        res.result.leaderPersionGropBo = {
                            name: '',
                            address: '',
                            website: '',
                            industry: '',
                            listed: '',
                            party: '',
                            leaderReason: [],
                            companyIntro: '',
                            personIntro: '',
                            honor: '',
                            // 资产
                            propertyBo: {
                                yesterassets: '',
                                yetersale: '',
                                yesterstaffNum: '',
                                yestergrowth: '',
                                beforeassets: '',
                                beforesale: '',
                                beforestaffNum: '',
                                beforegrowth: ''
                            },
                            // 上市
                            beforeList: '',//未来三年是否有上市计划（1有 2无）
                            listProcess: '',//上市进程（1未股改 2已股改 3提交申请）
                            listPlate: '',//拟上市板块(1上交所主板 2上交所科创板 3深交所主板 4深交所创业板 5北交所)
                            industryDetails: '',//	行业具体细分领域
                            corpType: '',//	企业类型（1国有 2合资 3民营 4其他）
                            organizingCord: '',//	企业组织机构代码
                            leadingProduct: '',//	主导产品名称
                            leadingProductType: '',//	主导产品类别
                            leadingProductYear: '',//	主导产品时间
                            leadingProductProportion: '',//	主营业务收入占营业收入比重
                            patentNum: '',//	专利数量
                            patent1: '',//	发明专利数量
                            patent2: '',//	植物新品种
                            patent3: '',//国家级农作物品种数量
                            patent4: '',//	国家新药数量
                            patent5: '',//	集成电路布图设计专有权数量
                            isDirectMating: '',//	是否为国内外知名大企业直接配套
                            directMatingNames: '',//	配套相关产品
                            isCloudCorner: '',//	业务系统是否向云端迁移(1有 2无)
                            havCoalesceProject: '',//	有无制造业和工业互联网融合示范项目(1有 2无)
                            coreBusinessSystem: [],//	核心业务采用信息系统支撑情况
                            coreBusinessSystemExplain: '',//	核心业务采用信息系统支撑情况-其他说明
                            productStandard: '',//	产品生产执行标准
                            regionalCertification: '',//	产品获得发达国家或地区权威认证
                            managerCertification: '',//	企业获得的管理体系认证
                            governmentCertification: '',//	获得相关部门认定的称号
                            governmentCertificationExplain: '',//	获得相关部门认定的称号-其他说明
                        }
                    }
                    // 开票信息
                    if (res.result.busBillInfoVo) {
                        if (res.result.busBillInfoVo.area) {
                            res.result.busBillInfoVo.area = res.result.busBillInfoVo.area.split(',')
                            res.result.areacity.province = res.result.busBillInfoVo.area[0]
                            res.result.areacity.town = res.result.busBillInfoVo.area[1]
                            res.result.areacity.county = res.result.busBillInfoVo.area[2]
                        } else {
                            res.result.areacity.province = '';
                            res.result.areacity.town = '';
                            res.result.areacity.county = '';
                        }
                        res.result.busBillInfoBo = res.result.busBillInfoVo
                        this.billnatureValue = res.result.busBillInfoVo.billnature
                        this.kindVal = res.result.busBillInfoVo.billkind
                        if (res.result.busBillInfoVo.payMentVoucher) {
                            let filelist = res.result.busBillInfoVo.payMentVoucher.split(',');
                            filelist = filelist.map((imgSrc, index) => {
                                return {
                                    url: srcUrl + imgSrc,
                                    uid: index,
                                    name: imgSrc
                                };
                            });
                            this.payfileList = filelist
                        }
                    } else {
                        res.result.busBillInfoBo = {
                            // billTypes: '',
                            corpName: '',
                            organizingCord: '',
                            billkind: '',
                            billnature: '',
                            billsite: '',
                            billphone: '',
                            bankName: '',
                            bankUserName: '',
                            billemail: '',
                            linkman: '',
                            phone: '',
                            acceptSite: '',//详细地址
                            area: '',//所在地区
                            payMentVoucher: '',
                        }
                    }


                    // 社会职务为空时
                    if (!res.result.leaderPostionVos || res.result.leaderPostionVos.length == 0) {
                        res.result.leaderPostionBoS = [{
                            positionGroup: '',
                            joinTime: '',
                            position: ''
                        }]
                    } else {
                        res.result.leaderPostionBoS = res.result.leaderPostionVos
                    }
                    // 轉时间
                    if (res.result.times) {
                        res.result.times = res.result.times.split('~')
                    }
                    delete res.result.leaderPersionGropVo
                    delete res.result.leaderPersionGropBo.propertyVoo
                    delete res.result.leaderPostionVos
                    delete res.result.busBillInfoVo
                    this.formData = res.result

                    this.isListed = this.formData.leaderPersionGropBo.listed == '否';
                    this.isListingPlan = this.formData.leaderPersionGropBo.beforeList == '有';
                    this.isMating = this.formData.leaderPersionGropBo.isDirectMating === '是';
                    if (this.formData.leaderPersionGropBo.coreBusinessSystem.includes('382')) {
                        this.isInput = true;
                    }
                    this.isGovernment = this.formData.leaderPersionGropBo.governmentCertification == 410;
                    //         imgfileList: [],
                    // letterfileList: [],
                    // secondfileList: [],
                    // thirdfileList: [],
                    if (res.result.leaderResourceWayVo) {
                        // 其他文件
                        if (res.result.leaderResourceWayVo.file) {
                            let filelist = res.result.leaderResourceWayVo.file.split(',');
                            filelist = filelist.map((imgSrc, index) => {
                                return {
                                    url: srcUrl + imgSrc,
                                    uid: index,
                                    name: imgSrc
                                };
                            });
                            this.fileList = filelist
                        }
                        // 推荐信 letterfileList
                        if (res.result.leaderResourceWayVo.nominate) {
                            let filelist = res.result.leaderResourceWayVo.nominate.split(',');
                            filelist = filelist.map((imgSrc, index) => {
                                return {
                                    url: srcUrl + imgSrc,
                                    uid: index,
                                    name: imgSrc
                                };
                            });
                            this.letterfileList = filelist
                        }
                        // 电子版照片 secondfileList
                        if (res.result.leaderResourceWayVo.peopleImg) {
                            let filelist = res.result.leaderResourceWayVo.peopleImg.split(',');
                            filelist = filelist.map((imgSrc, index) => {
                                return {
                                    url: srcUrl + imgSrc,
                                    uid: index,
                                    name: imgSrc
                                };
                            });
                            this.secondfileList = filelist
                        }
                        // 视频
                        if (res.result.leaderResourceWayVo.video) {
                            let filelist = res.result.leaderResourceWayVo.video.split(',');
                            filelist = filelist.map((imgSrc, index) => {
                                return {
                                    url: srcUrl + imgSrc,
                                    uid: index,
                                    name: imgSrc
                                };
                            });
                            this.thirdfileList = filelist
                            this.videodata = res.result.leaderResourceWayVo.video
                        }
                        // 学员选拔表 
                        if (res.result.leaderResourceWayVo.selectinfo) {
                            let filelist = res.result.leaderResourceWayVo.selectinfo.split(',');
                            filelist = filelist.map((imgSrc, index) => {
                                return {
                                    url: srcUrl + imgSrc,
                                    uid: index,
                                    name: imgSrc
                                };
                            });
                            this.imgfileList = filelist
                        }
                    } else {
                        this.fileList = [];
                        this.letterfileList = [];
                        this.secondfileList = [];
                        this.thirdfileList = [];
                        this.imgfileList = []
                    }
                    // 所在区域
                    if (this.formData.city.town) {
                        let provinceId
                        this.addressProvinceArr.map(item => {
                            if (item.province === this.formData.city.province) {
                                return provinceId = item.provinceId
                            }
                        })
                        this.getCityData(provinceId)
                    }
                    // 所在地區
                    if (this.formData.areacity.town) {
                        let provinceId
                        this.ProvinceArr.map(item => {
                            if (item.province === this.formData.areacity.province) {
                                return provinceId = item.provinceId
                            }
                        })
                        this.getareaCityData(provinceId)
                    }
                    this.recommendLetter = res.result.recommendLetter
                    this.studentTableUrl = res.result.studentTableUrl
                    this.$nextTick(() => {
                        if (this.auditResult == 3 || this.auditResult == 101 || this.auditResult == 100 || this.auditResult == 2 || this.auditResult == 4 || this.auditResult == 5) {
                            if (this.imgfileList.length > 0) {
                                this.$refs.imgupload.$el.firstChild.nextSibling.style.display = 'none'
                                // document.querySelector('#imgupload').firstChild.nextSibling.style.display = 'none'
                            }
                            if (this.letterfileList.length > 0) {
                                document.querySelector('#letterupload').firstChild.nextSibling.style.display = 'none'
                            }
                        }
                        // if (this.secondfileList.length >= 3) {
                        //     document.querySelector('#peopleimgupload').firstChild.nextSibling.style.display = 'none'
                        // }
                        if (this.billAudit == 1 && this.payfileList.length > 0) {
                            // this.$refs.payupload.$el.firstChild.nextSibling.style.display = 'none'
                            document.querySelector('#payupload').firstChild.nextSibling.style.display = 'none'
                        }
                        // DOM 更新了
                        this.$refs["formData"].clearValidate()
                    })
                }
            })
        },
        // 文件上传相关
        // 图片上传
        handleAvatarSuccess(res, file, fileList) {
            if (res.code == 200) {
                this.imgfileList = fileList
                if (this.imgfileList.length > 0) {
                    document.querySelector('#imgupload').firstChild.nextSibling.style.display = 'none'
                }
            }
        },
        // 删除
        handleRemove(file, fileList) {
            this.imgfileList = []
            if (this.imgfileList.length == 0) {
                document.querySelector('#imgupload').firstChild.nextSibling.style.display = 'inline-block'
            }
        },
        // 推荐信
        letterSuccess(res, file, fileList) {
            if (res.code == 200) {
                this.letterfileList = fileList
                if (this.letterfileList.length > 0) {
                    document.querySelector('#letterupload').firstChild.nextSibling.style.display = 'none'
                }
            }
        },
        // 删除
        letterRemove(file, fileList) {
            this.letterfileList = []
            if (this.letterfileList.length == 0) {
                document.querySelector('#letterupload').firstChild.nextSibling.style.display = 'inline-block'
            }
        },
        // // 第三个上传
        // secondSuccessFn(res, file, fileList) {
        //     if (res.code == 200) {
        //         this.secondfileList = fileList
        //     }
        //     if (this.secondfileList.length >= 3) {
        //         document.querySelector('#peopleimgupload').firstChild.nextSibling.style.display = 'none'
        //     }
        // },
        // secondRemoveFn(file, fileList) {
        //     this.secondfileList = fileList
        //     if (this.secondfileList.length < 3) {
        //         document.querySelector('#peopleimgupload').firstChild.nextSibling.style.display = 'block'
        //     }
        // },
        // // 视频
        // thirdSuccessFn(res, file, fileList) {
        //     if (res.code == 200) {
        //         this.thirdfileList = fileList
        //         this.formData.video = res.result
        //         if (this.letterfileList.length > 0) {
        //             document.querySelector('#uploadmedia').firstChild.nextSibling.style.display = 'none'
        //         }
        //     }
        // },
        // thirdRemoveFn(file, fileList) {
        //     this.thirdfileList = []
        //     if (this.letterfileList.length == 0) {
        //         document.querySelector('#uploadmedia').firstChild.nextSibling.style.display = 'inline-block'
        //     }
        // },
        // deleteVideo() {
        //     this.thirdfileList = []
        //     this.formData.video = ''
        //     if (this.letterfileList.length == 0) {
        //         document.querySelector('#uploadmedia').firstChild.nextSibling.style.display = 'inline-block'
        //     }
        // },
        // // 其他文件
        // // 文件
        // handlefileSuccess(res, file, fileList) {
        //     if (res.code == 200) {
        //         this.fileList = fileList
        //     }
        // },
        // handlefileRemove(file, fileList) {
        //     this.fileList = fileList
        // },
        // 单位性质
        billnatureFn(value) {
            this.billnatureValue = value
            if (this.kindVal == '增值税专用发票' && value == '小规模纳税人') {
                this.formData.busBillInfoBo.billkind = '增值税普通发票'
            }
        },
        billkindFn(value) {
            this.kindVal = value
        },
        // 返回
        returnListFn() {
            this.$router.push('/account-center/train-course');
        },
        // 提交表单
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.isloading = true
                    // 第二步直接提交或者审核失败
                    if (this.auditResult == '199' || this.auditResult == '98') {
                        this.formData.auditResult = 99
                        if (Array.isArray(this.formData.leaderPersionGropBo.address)) {
                            this.formData.leaderPersionGropBo.address = this.formData.leaderPersionGropBo.address.join(',')
                        }
                        if (Array.isArray(this.formData.busBillInfoBo.area)) {
                            this.formData.busBillInfoBo.area = this.formData.busBillInfoBo.area.join(',')
                        }
                        // this.formData.trainId = this.leartrainData.trainId
                        let newdataform = JSON.parse(JSON.stringify(this.formData))
                        if (Array.isArray(newdataform.times)) {
                            newdataform.times = newdataform.times.join('~')
                        }
                        if (Array.isArray(newdataform.leaderPersionGropBo.coreBusinessSystem)) {
                            if (newdataform.leaderPersionGropBo.coreBusinessSystem.length != 0) {
                                newdataform.leaderPersionGropBo.coreBusinessSystem = newdataform.leaderPersionGropBo.coreBusinessSystem.join(',')
                            } else {
                                newdataform.leaderPersionGropBo.coreBusinessSystem = ''
                            }
                        }
                        let key = { joinTime: "", position: "", positionGroup: "" };
                        newdataform.leaderPostionBoS = []
                        this.formData.leaderPostionBoS.map(item => {
                            let flag = 0;
                            for (let k in key) {
                                if (item[k] == "") {
                                    flag++;
                                }
                            }
                            if (flag !== 3) {
                                newdataform.leaderPostionBoS.push(item)
                            }
                        })
                        delete newdataform.city
                        delete newdataform.areacity
                        httpService.GooseleaderPersonRejectUpdate(newdataform).then(res => {
                            if (res) {
                                this.isloading = false
                                if (res.code == 200) {
                                    // this.getyetFormFn()
                                    this.$message({
                                        message: '详细信息提交成功',
                                        type: 'success'
                                    });
                                    this.$router.push({
                                        path: "/account-center/train-course",
                                    });
                                } else {
                                    this.$message.error(res.message);
                                }
                            }
                        })
                    }
                    // 第三步 3
                    else {
                        this.fileSubmitFN()
                    }

                } else {
                    return false;
                }
            });

        },
        // 下载学员选拔表
        downloadFileFn() {
            // this.downloadFlag = true
            // this.downText = '推荐信'
            this.fileFn(this.recommendLetter)
            // this.submitForm('formData')
        },
        downloadRecommendFn() {
            this.fileFn(this.studentTableUrl)

            // this.downloadFlag = true
            // this.downText = '选拔表'
            // this.submitForm('formData')
        },
        // 上传表单第三步
        fileSubmitFN() {
            let selectinfo, nominate
            if (this.letterfileList.length != 0) {
                this.letterfileList.forEach(item => {
                    if (item.response) {
                        return nominate = item.response.result
                    } else {
                        return nominate = item.name
                    }
                })
            }
            if (this.imgfileList.length != 0) {
                this.imgfileList.forEach(item => {
                    if (item.response) {
                        return selectinfo = item.response.result
                    } else {
                        return selectinfo = item.name
                    }
                })
            }
            // // 电子照片
            // if (this.secondfileList.length != 0) {
            //     this.secondfileList.map(item => {
            //         if (item.response) {
            //             return applyDataUrl1.push(item.response.result)
            //         } else {
            //             return applyDataUrl1.push(item.name)
            //         }
            //     })
            // }
            // // 视频
            // if (this.thirdfileList.length != 0) {
            //     this.thirdfileList.forEach(item => {

            //         if (item.response) {
            //             return video = item.response.result
            //         } else {
            //             return video = item.name
            //         }
            //     })
            // }
            // 其他文件
            // if (this.fileList.length != 0) {
            //     this.fileList.map(item => {
            //         if (item.response) {
            //             return applyDataUrl2.push(item.response.result)
            //         } else {
            //             return applyDataUrl2.push(item.name)
            //         }
            //     })
            // }
            // if (!selectinfo || applyDataUrl1.length < 3 || !video) {
            //     this.$message.error('请按要求上传所需文件图片');
            //     return
            // }
            // else {
            let data = {
                selectinfo,
                nominate,
                // video,
                // peopleImg: applyDataUrl1.join(','),
                // file: applyDataUrl2.join(','),
                // status: 1,
                auditResult: 1
            }
            httpService.GoosesubmitLeaderTalent(data).then(res => {
                if (res.code == 200) {
                    this.$message({
                        message: '文件上传提交成功',
                        type: 'success'
                    });
                    this.$router.push({
                        path: "/account-center/train-course",
                    });
                } else {
                    this.$message.error(res.message);
                }
            })
            // }
        },
        removeDomain(item) {
            var index = this.formData.leaderPostionBoS.indexOf(item)
            if (index !== -1) {
                this.formData.leaderPostionBoS.splice(index, 1)
            }
            this.singupserialNumber = this.singupserialNumber - 1
        },
        addDomain() {
            this.formData.leaderPostionBoS.push({
                positionGroup: '',
                joinTime: '',
                position: ''
            });
            this.singupserialNumber = this.singupserialNumber++
        },
        deleDomain() {
            this.formData.leaderPostionBoS.forEach((ele, index) => {

                if (ele.checked) {
                    this.formData.leaderPostionBoS.splice(index)
                }
                else {
                    this.showdelete = true
                }
            });
        },
        fileFn(val) {
            let Docurl = `http:${
                process.env.VUE_APP_WZ
                }${"/upload/download?session="}${val}`;

            let a = document.createElement("a");
            document.body.appendChild(a);
            a.style.display = "none";
            a.setAttribute("download", "");
            a.setAttribute("target", "_self");
            a.setAttribute("href", Docurl);
            a.click();
        }
    }
}
</script>
<style lang="less" scoped>
.LeadApplyDetailsWarp {
  padding: 30px 180px 0 31px;
  box-sizing: border-box;
  display: flex;
  flex-direction: row;
  .titleBox {
    width: 300px;
    font-size: 24px;
    font-weight: bold;
    line-height: 24px;
    color: #43424b;
  }
  .yearbox {
    font-size: 15px;
    line-height: 40px;
    color: #a6a9b7;
    &::before {
      position: absolute;
      top: 12px;
      left: 0px;
      // margin-right: 4px;
      color: #ff4d4f;
      font-size: 16px;
      font-family: SimSun, sans-serif;
      line-height: 1;
      content: "*";
    }
  }
  .deteleIcon {
    font-size: 21px;
    cursor: pointer;
    color: red;
    line-height: 40px;
    margin-left: 4px;
  }
  // .honor {
  // 	// margin-left: 20px;
  // 	position: relative;
  // 	&::before {
  // 		position: absolute;
  // 		top: 16px;
  // 		left: -10px;
  // 		// margin-right: 4px;
  // 		color: #ff4d4f;
  // 		font-size: 16px;
  // 		font-family: SimSun, sans-serif;
  // 		line-height: 1;
  // 		content: '*';
  // 	}
  // }
  /deep/.singupdialogcenter {
    padding: 0px 0px 0px 20px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    align-items: center;

    .courseBox1 {
      width: 100%;
      display: flex;
      flex-direction: row;
      justify-content: center;
      padding-bottom: 32px;
      border-bottom: 1px solid #dddddd;
      margin-bottom: 20px;
      .courseinfo {
        margin: 0 132px;
        font-size: 16px;
        line-height: 54px;
        color: #333333;
        .text {
          font-size: 16px;
          margin-right: 20px;
          line-height: 54px;
          color: #a6a9b7;
        }
      }
    }
    /deep/.el-checkbox__inner {
      border-radius: 50%;
    }
    .singupForm {
      width: 100%;
      .singupInfowarp {
        padding-bottom: 32px;
        border-bottom: 1px solid #dddddd;
        margin-bottom: 20px;
        // padding: 0 60px;
      }
      .singupInfobox {
        // padding-bottom: 32px;
        // border-bottom: 1px solid #dddddd;
        // margin-bottom: 20px;
        padding: 0 30px;
        .header {
          height: 24px;
          font-size: 18px;
          font-weight: bold;
          line-height: 24px;
          color: #43424b;
          margin-bottom: 16px;
          .education {
            font-size: 16px;
            line-height: 54px;
            color: #999999;
          }
        }
        .btnwarp {
          font-size: 16px;
          // line-height: 54px;
          display: flex;
          flex-direction: row;
          justify-content: center;

          .icon {
            margin-right: 5px;
          }
          .addbtn {
            color: #0083ff;
            margin: 0 20px;
            cursor: pointer;
          }
          .deletebtn {
            color: #ff3c3c;
            margin: 0 20px;
            cursor: pointer;
          }
        }
      }
      .header {
        height: 24px;
        font-size: 18px;
        font-weight: bold;
        line-height: 24px;
        color: #43424b;
        margin-bottom: 16px;
        .education {
          font-size: 16px;
          line-height: 54px;
          color: #999999;
          padding-left: 6px;
        }
      }
      .educationInfoBox {
        .header {
          margin-left: 30px;
          margin-bottom: 20px;
        }
        // border-bottom: 1px solid #dddddd;
        // margin-bottom: 20px;
        // padding: 0 0px 30px 0px;
      }
      .makeoutInfoBox {
        border-bottom: 1px solid #dddddd;
        margin-bottom: 20px;
        padding: 0 30px 30px 30px;
        .textbox {
          // width: 320px;
          display: flex;
          flex-direction: row;
          align-content: center;
          align-items: center;
          // justify-content: space-between;
          // width: 50%;
          margin: 20px auto 0 auto;
          font-size: 16px;
          color: #333333;
          margin-bottom: 20px;

          .leftbox {
            display: flex;
            flex-direction: row;
            align-content: center;
            align-items: center;
            margin: 0 24px 0 20px;
            .imgbox {
              width: 30px;
              height: 30px;
            }
          }
          .downBox {
            width: 50px;
            text-align: center;
            line-height: 20px;
            height: 20px;
            background: #ffffff;
            border-radius: 13px 13px 13px 13px;
            color: #0e83fc;
            font-size: 14px;
            border: 1px solid #0e83fc;
            cursor: pointer;
          }
          // span,

          // .iconbox {
          // 	color: #448df7;
          // 	cursor: pointer;
          // }
          // .iconbox {
          // 	margin-left: 4px;
          // }
        }
        .header {
          height: 24px;
          font-size: 18px;
          font-weight: bold;
          line-height: 24px;
          color: #43424b;
          margin-bottom: 16px;
          .education {
            font-size: 16px;
            line-height: 54px;
            color: #999999;
            padding-left: 6px;
          }
        }
      }
      .fileBox {
        margin-bottom: 20px;
        padding: 0 30px 0px 30px;
        .header {
          height: 24px;
          font-size: 18px;
          font-weight: bold;
          line-height: 24px;
          color: #43424b;
          margin-bottom: 16px;
        }
      }
      .formBtnBox {
        display: flex;
        fill-opacity: row;
        justify-content: center;
        .submitBtn {
          width: 152px;
          height: 40px;
          background: #349cff;
          margin: 0 20px;
        }
        .cancelBtn {
          width: 152px;
          height: 40px;
          background: #ffc56d;
          margin: 0 20px;
          color: #fff;
          border: 1px solid #ffc56d;
        }
        .returnBtn {
          width: 152px;
          height: 40px;
          border: 1px solid #a6a9b7;
          border-radius: 5px;
          margin: 0 20px;
        }
      }
      .label10 {
        /deep/.el-form-item__label {
          padding-left: 12px;

          position: relative;
          &::before {
            // position: absolute;
            top: 12px;
            left: 0px;
            // margin-right: 4px;
            color: #ff4d4f;
            font-size: 16px;
            font-family: SimSun, sans-serif;
            line-height: 1;
            content: "*";
          }
        }
      }
      /deep/.el-upload--picture-card {
        background-color: #fbfdff;
        border: 1px dashed #c0ccda;
        border-radius: 6px;
        box-sizing: border-box;
        width: 80px;
        height: 80px;
        line-height: 86px;
        vertical-align: top;
      }
      // .applicationimg {
      // 	width: 80px;
      // 	height: 80px;
      // }
      /deep/.el-upload-list--picture-card .el-upload-list__item {
        width: 80px;
        height: 80px;
      }
    }
  }
  .yearbox {
    font-size: 15px;
    line-height: 40px;
    color: #a6a9b7;
  }
  .deteleIcon {
    font-size: 21px;
    cursor: pointer;
    color: red;
    line-height: 40px;
    margin-left: 4px;
  }
  .imgwarp {
    display: flex;
    flex-direction: row;
    // margin-left: 140px;
    // flex-wrap: wrap;
    video {
      object-fit: fill;
    }
    .spanbox {
      margin-left: 10px;
      .videoicon {
        font-size: 20px;
        cursor: pointer;
      }
      &:hover {
        // background: rgb(179, 220, 247);
        color: #349cff;
      }
    }
  }
  .videoFormItem {
    position: relative;
    .videoText {
      position: absolute;
      top: 20px;
      left: -74px;
      cursor: pointer;
      font-size: 14px;
      color: #ff8916;
    }
  }
  .singeimgbox {
    width: 300px;
    height: 180px;
  }
  .otherwarp {
    display: flex;
    flex-direction: column;
  }
  .imgbox {
    display: flex;
    flex-direction: row;
    width: 80px;
    margin-right: 10px;
  }
  .imgtitlebox {
    font-size: 14px;
    color: #606266;
    line-height: 40px;
  }
}
</style>


